"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
;
exports.extendedPictographic = /^[\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9-\u21AA\u231A-\u231B\u2328\u2388\u23CF\u23E9-\u23EC\u23ED-\u23EE\u23EF\u23F0\u23F1-\u23F2\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2601\u2602-\u2603\u2604\u2605\u2607-\u260D\u260E\u260F-\u2610\u2611\u2612\u2614-\u2615\u2616-\u2617\u2618\u2619-\u261C\u261D\u261E-\u261F\u2620\u2621\u2622-\u2623\u2624-\u2625\u2626\u2627-\u2629\u262A\u262B-\u262D\u262E\u262F\u2630-\u2637\u2638-\u2639\u263A\u263B-\u263F\u2640\u2641\u2642\u2643-\u2647\u2648-\u2653\u2654-\u265E\u265F\u2660\u2661-\u2662\u2663\u2664\u2665-\u2666\u2667\u2668\u2669-\u267A\u267B\u267C-\u267D\u267E\u267F\u2680-\u2685\u2690-\u2691\u2692\u2693\u2694\u2695\u2696-\u2697\u2698\u2699\u269A\u269B-\u269C\u269D-\u269F\u26A0-\u26A1\u26A2-\u26A6\u26A7\u26A8-\u26A9\u26AA-\u26AB\u26AC-\u26AF\u26B0-\u26B1\u26B2-\u26BC\u26BD-\u26BE\u26BF-\u26C3\u26C4-\u26C5\u26C6-\u26C7\u26C8\u26C9-\u26CD\u26CE\u26CF\u26D0\u26D1\u26D2\u26D3\u26D4\u26D5-\u26E8\u26E9\u26EA\u26EB-\u26EF\u26F0-\u26F1\u26F2-\u26F3\u26F4\u26F5\u26F6\u26F7-\u26F9\u26FA\u26FB-\u26FC\u26FD\u26FE-\u2701\u2702\u2703-\u2704\u2705\u2708-\u270C\u270D\u270E\u270F\u2710-\u2711\u2712\u2714\u2716\u271D\u2721\u2728\u2733-\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2765-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934-\u2935\u2B05-\u2B07\u2B1B-\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299\u{01F000}-\u{01F003}\u{01F004}\u{01F005}-\u{01F0CE}\u{01F0CF}\u{01F0D0}-\u{01F0FF}\u{01F10D}-\u{01F10F}\u{01F12F}\u{01F16C}-\u{01F16F}\u{01F170}-\u{01F171}\u{01F17E}-\u{01F17F}\u{01F18E}\u{01F191}-\u{01F19A}\u{01F1AD}-\u{01F1E5}\u{01F201}-\u{01F202}\u{01F203}-\u{01F20F}\u{01F21A}\u{01F22F}\u{01F232}-\u{01F23A}\u{01F23C}-\u{01F23F}\u{01F249}-\u{01F24F}\u{01F250}-\u{01F251}\u{01F252}-\u{01F2FF}\u{01F300}-\u{01F30C}\u{01F30D}-\u{01F30E}\u{01F30F}\u{01F310}\u{01F311}\u{01F312}\u{01F313}-\u{01F315}\u{01F316}-\u{01F318}\u{01F319}\u{01F31A}\u{01F31B}\u{01F31C}\u{01F31D}-\u{01F31E}\u{01F31F}-\u{01F320}\u{01F321}\u{01F322}-\u{01F323}\u{01F324}-\u{01F32C}\u{01F32D}-\u{01F32F}\u{01F330}-\u{01F331}\u{01F332}-\u{01F333}\u{01F334}-\u{01F335}\u{01F336}\u{01F337}-\u{01F34A}\u{01F34B}\u{01F34C}-\u{01F34F}\u{01F350}\u{01F351}-\u{01F37B}\u{01F37C}\u{01F37D}\u{01F37E}-\u{01F37F}\u{01F380}-\u{01F393}\u{01F394}-\u{01F395}\u{01F396}-\u{01F397}\u{01F398}\u{01F399}-\u{01F39B}\u{01F39C}-\u{01F39D}\u{01F39E}-\u{01F39F}\u{01F3A0}-\u{01F3C4}\u{01F3C5}\u{01F3C6}\u{01F3C7}\u{01F3C8}\u{01F3C9}\u{01F3CA}\u{01F3CB}-\u{01F3CE}\u{01F3CF}-\u{01F3D3}\u{01F3D4}-\u{01F3DF}\u{01F3E0}-\u{01F3E3}\u{01F3E4}\u{01F3E5}-\u{01F3F0}\u{01F3F1}-\u{01F3F2}\u{01F3F3}\u{01F3F4}\u{01F3F5}\u{01F3F6}\u{01F3F7}\u{01F3F8}-\u{01F3FA}\u{01F400}-\u{01F407}\u{01F408}\u{01F409}-\u{01F40B}\u{01F40C}-\u{01F40E}\u{01F40F}-\u{01F410}\u{01F411}-\u{01F412}\u{01F413}\u{01F414}\u{01F415}\u{01F416}\u{01F417}-\u{01F429}\u{01F42A}\u{01F42B}-\u{01F43E}\u{01F43F}\u{01F440}\u{01F441}\u{01F442}-\u{01F464}\u{01F465}\u{01F466}-\u{01F46B}\u{01F46C}-\u{01F46D}\u{01F46E}-\u{01F4AC}\u{01F4AD}\u{01F4AE}-\u{01F4B5}\u{01F4B6}-\u{01F4B7}\u{01F4B8}-\u{01F4EB}\u{01F4EC}-\u{01F4ED}\u{01F4EE}\u{01F4EF}\u{01F4F0}-\u{01F4F4}\u{01F4F5}\u{01F4F6}-\u{01F4F7}\u{01F4F8}\u{01F4F9}-\u{01F4FC}\u{01F4FD}\u{01F4FE}\u{01F4FF}-\u{01F502}\u{01F503}\u{01F504}-\u{01F507}\u{01F508}\u{01F509}\u{01F50A}-\u{01F514}\u{01F515}\u{01F516}-\u{01F52B}\u{01F52C}-\u{01F52D}\u{01F52E}-\u{01F53D}\u{01F546}-\u{01F548}\u{01F549}-\u{01F54A}\u{01F54B}-\u{01F54E}\u{01F54F}\u{01F550}-\u{01F55B}\u{01F55C}-\u{01F567}\u{01F568}-\u{01F56E}\u{01F56F}-\u{01F570}\u{01F571}-\u{01F572}\u{01F573}-\u{01F579}\u{01F57A}\u{01F57B}-\u{01F586}\u{01F587}\u{01F588}-\u{01F589}\u{01F58A}-\u{01F58D}\u{01F58E}-\u{01F58F}\u{01F590}\u{01F591}-\u{01F594}\u{01F595}-\u{01F596}\u{01F597}-\u{01F5A3}\u{01F5A4}\u{01F5A5}\u{01F5A6}-\u{01F5A7}\u{01F5A8}\u{01F5A9}-\u{01F5B0}\u{01F5B1}-\u{01F5B2}\u{01F5B3}-\u{01F5BB}\u{01F5BC}\u{01F5BD}-\u{01F5C1}\u{01F5C2}-\u{01F5C4}\u{01F5C5}-\u{01F5D0}\u{01F5D1}-\u{01F5D3}\u{01F5D4}-\u{01F5DB}\u{01F5DC}-\u{01F5DE}\u{01F5DF}-\u{01F5E0}\u{01F5E1}\u{01F5E2}\u{01F5E3}\u{01F5E4}-\u{01F5E7}\u{01F5E8}\u{01F5E9}-\u{01F5EE}\u{01F5EF}\u{01F5F0}-\u{01F5F2}\u{01F5F3}\u{01F5F4}-\u{01F5F9}\u{01F5FA}\u{01F5FB}-\u{01F5FF}\u{01F600}\u{01F601}-\u{01F606}\u{01F607}-\u{01F608}\u{01F609}-\u{01F60D}\u{01F60E}\u{01F60F}\u{01F610}\u{01F611}\u{01F612}-\u{01F614}\u{01F615}\u{01F616}\u{01F617}\u{01F618}\u{01F619}\u{01F61A}\u{01F61B}\u{01F61C}-\u{01F61E}\u{01F61F}\u{01F620}-\u{01F625}\u{01F626}-\u{01F627}\u{01F628}-\u{01F62B}\u{01F62C}\u{01F62D}\u{01F62E}-\u{01F62F}\u{01F630}-\u{01F633}\u{01F634}\u{01F635}\u{01F636}\u{01F637}-\u{01F640}\u{01F641}-\u{01F644}\u{01F645}-\u{01F64F}\u{01F680}\u{01F681}-\u{01F682}\u{01F683}-\u{01F685}\u{01F686}\u{01F687}\u{01F688}\u{01F689}\u{01F68A}-\u{01F68B}\u{01F68C}\u{01F68D}\u{01F68E}\u{01F68F}\u{01F690}\u{01F691}-\u{01F693}\u{01F694}\u{01F695}\u{01F696}\u{01F697}\u{01F698}\u{01F699}-\u{01F69A}\u{01F69B}-\u{01F6A1}\u{01F6A2}\u{01F6A3}\u{01F6A4}-\u{01F6A5}\u{01F6A6}\u{01F6A7}-\u{01F6AD}\u{01F6AE}-\u{01F6B1}\u{01F6B2}\u{01F6B3}-\u{01F6B5}\u{01F6B6}\u{01F6B7}-\u{01F6B8}\u{01F6B9}-\u{01F6BE}\u{01F6BF}\u{01F6C0}\u{01F6C1}-\u{01F6C5}\u{01F6C6}-\u{01F6CA}\u{01F6CB}\u{01F6CC}\u{01F6CD}-\u{01F6CF}\u{01F6D0}\u{01F6D1}-\u{01F6D2}\u{01F6D3}-\u{01F6D4}\u{01F6D5}\u{01F6D6}-\u{01F6D7}\u{01F6D8}-\u{01F6DF}\u{01F6E0}-\u{01F6E5}\u{01F6E6}-\u{01F6E8}\u{01F6E9}\u{01F6EA}\u{01F6EB}-\u{01F6EC}\u{01F6ED}-\u{01F6EF}\u{01F6F0}\u{01F6F1}-\u{01F6F2}\u{01F6F3}\u{01F6F4}-\u{01F6F6}\u{01F6F7}-\u{01F6F8}\u{01F6F9}\u{01F6FA}\u{01F6FB}-\u{01F6FC}\u{01F6FD}-\u{01F6FF}\u{01F774}-\u{01F77F}\u{01F7D5}-\u{01F7DF}\u{01F7E0}-\u{01F7EB}\u{01F7EC}-\u{01F7FF}\u{01F80C}-\u{01F80F}\u{01F848}-\u{01F84F}\u{01F85A}-\u{01F85F}\u{01F888}-\u{01F88F}\u{01F8AE}-\u{01F8FF}\u{01F90C}\u{01F90D}-\u{01F90F}\u{01F910}-\u{01F918}\u{01F919}-\u{01F91E}\u{01F91F}\u{01F920}-\u{01F927}\u{01F928}-\u{01F92F}\u{01F930}\u{01F931}-\u{01F932}\u{01F933}-\u{01F93A}\u{01F93C}-\u{01F93E}\u{01F93F}\u{01F940}-\u{01F945}\u{01F947}-\u{01F94B}\u{01F94C}\u{01F94D}-\u{01F94F}\u{01F950}-\u{01F95E}\u{01F95F}-\u{01F96B}\u{01F96C}-\u{01F970}\u{01F971}\u{01F972}\u{01F973}-\u{01F976}\u{01F977}-\u{01F978}\u{01F979}\u{01F97A}\u{01F97B}\u{01F97C}-\u{01F97F}\u{01F980}-\u{01F984}\u{01F985}-\u{01F991}\u{01F992}-\u{01F997}\u{01F998}-\u{01F9A2}\u{01F9A3}-\u{01F9A4}\u{01F9A5}-\u{01F9AA}\u{01F9AB}-\u{01F9AD}\u{01F9AE}-\u{01F9AF}\u{01F9B0}-\u{01F9B9}\u{01F9BA}-\u{01F9BF}\u{01F9C0}\u{01F9C1}-\u{01F9C2}\u{01F9C3}-\u{01F9CA}\u{01F9CB}\u{01F9CC}\u{01F9CD}-\u{01F9CF}\u{01F9D0}-\u{01F9E6}\u{01F9E7}-\u{01F9FF}\u{01FA00}-\u{01FA6F}\u{01FA70}-\u{01FA73}\u{01FA74}\u{01FA75}-\u{01FA77}\u{01FA78}-\u{01FA7A}\u{01FA7B}-\u{01FA7F}\u{01FA80}-\u{01FA82}\u{01FA83}-\u{01FA86}\u{01FA87}-\u{01FA8F}\u{01FA90}-\u{01FA95}\u{01FA96}-\u{01FAA8}\u{01FAA9}-\u{01FAAF}\u{01FAB0}-\u{01FAB6}\u{01FAB7}-\u{01FABF}\u{01FAC0}-\u{01FAC2}\u{01FAC3}-\u{01FACF}\u{01FAD0}-\u{01FAD6}\u{01FAD7}-\u{01FAFF}\u{01FC00}-\u{01FFFD}]/u;
exports.WORD_BREAK_PROPERTY = [
    [/*start*/ 0x0, 0 /* Other */],
    [/*start*/ 0xA, 1 /* LF */],
    [/*start*/ 0xB, 2 /* Newline */],
    [/*start*/ 0xD, 3 /* CR */],
    [/*start*/ 0xE, 0 /* Other */],
    [/*start*/ 0x20, 4 /* WSegSpace */],
    [/*start*/ 0x21, 0 /* Other */],
    [/*start*/ 0x22, 5 /* Double_Quote */],
    [/*start*/ 0x23, 0 /* Other */],
    [/*start*/ 0x27, 6 /* Single_Quote */],
    [/*start*/ 0x28, 0 /* Other */],
    [/*start*/ 0x2C, 7 /* MidNum */],
    [/*start*/ 0x2D, 0 /* Other */],
    [/*start*/ 0x2E, 8 /* MidNumLet */],
    [/*start*/ 0x2F, 0 /* Other */],
    [/*start*/ 0x30, 9 /* Numeric */],
    [/*start*/ 0x3A, 10 /* MidLetter */],
    [/*start*/ 0x3B, 7 /* MidNum */],
    [/*start*/ 0x3C, 0 /* Other */],
    [/*start*/ 0x41, 11 /* ALetter */],
    [/*start*/ 0x5B, 0 /* Other */],
    [/*start*/ 0x5F, 12 /* ExtendNumLet */],
    [/*start*/ 0x60, 0 /* Other */],
    [/*start*/ 0x61, 11 /* ALetter */],
    [/*start*/ 0x7B, 0 /* Other */],
    [/*start*/ 0x85, 2 /* Newline */],
    [/*start*/ 0x86, 0 /* Other */],
    [/*start*/ 0xAA, 11 /* ALetter */],
    [/*start*/ 0xAB, 0 /* Other */],
    [/*start*/ 0xAD, 13 /* Format */],
    [/*start*/ 0xAE, 0 /* Other */],
    [/*start*/ 0xB5, 11 /* ALetter */],
    [/*start*/ 0xB6, 0 /* Other */],
    [/*start*/ 0xB7, 10 /* MidLetter */],
    [/*start*/ 0xB8, 0 /* Other */],
    [/*start*/ 0xBA, 11 /* ALetter */],
    [/*start*/ 0xBB, 0 /* Other */],
    [/*start*/ 0xC0, 11 /* ALetter */],
    [/*start*/ 0xD7, 0 /* Other */],
    [/*start*/ 0xD8, 11 /* ALetter */],
    [/*start*/ 0xF7, 0 /* Other */],
    [/*start*/ 0xF8, 11 /* ALetter */],
    [/*start*/ 0x2D8, 0 /* Other */],
    [/*start*/ 0x2DE, 11 /* ALetter */],
    [/*start*/ 0x300, 14 /* Extend */],
    [/*start*/ 0x370, 11 /* ALetter */],
    [/*start*/ 0x375, 0 /* Other */],
    [/*start*/ 0x376, 11 /* ALetter */],
    [/*start*/ 0x378, 0 /* Other */],
    [/*start*/ 0x37A, 11 /* ALetter */],
    [/*start*/ 0x37E, 7 /* MidNum */],
    [/*start*/ 0x37F, 11 /* ALetter */],
    [/*start*/ 0x380, 0 /* Other */],
    [/*start*/ 0x386, 11 /* ALetter */],
    [/*start*/ 0x387, 10 /* MidLetter */],
    [/*start*/ 0x388, 11 /* ALetter */],
    [/*start*/ 0x38B, 0 /* Other */],
    [/*start*/ 0x38C, 11 /* ALetter */],
    [/*start*/ 0x38D, 0 /* Other */],
    [/*start*/ 0x38E, 11 /* ALetter */],
    [/*start*/ 0x3A2, 0 /* Other */],
    [/*start*/ 0x3A3, 11 /* ALetter */],
    [/*start*/ 0x3F6, 0 /* Other */],
    [/*start*/ 0x3F7, 11 /* ALetter */],
    [/*start*/ 0x482, 0 /* Other */],
    [/*start*/ 0x483, 14 /* Extend */],
    [/*start*/ 0x48A, 11 /* ALetter */],
    [/*start*/ 0x530, 0 /* Other */],
    [/*start*/ 0x531, 11 /* ALetter */],
    [/*start*/ 0x557, 0 /* Other */],
    [/*start*/ 0x559, 11 /* ALetter */],
    [/*start*/ 0x55D, 0 /* Other */],
    [/*start*/ 0x55E, 11 /* ALetter */],
    [/*start*/ 0x55F, 10 /* MidLetter */],
    [/*start*/ 0x560, 11 /* ALetter */],
    [/*start*/ 0x589, 7 /* MidNum */],
    [/*start*/ 0x58A, 11 /* ALetter */],
    [/*start*/ 0x58B, 0 /* Other */],
    [/*start*/ 0x591, 14 /* Extend */],
    [/*start*/ 0x5BE, 0 /* Other */],
    [/*start*/ 0x5BF, 14 /* Extend */],
    [/*start*/ 0x5C0, 0 /* Other */],
    [/*start*/ 0x5C1, 14 /* Extend */],
    [/*start*/ 0x5C3, 0 /* Other */],
    [/*start*/ 0x5C4, 14 /* Extend */],
    [/*start*/ 0x5C6, 0 /* Other */],
    [/*start*/ 0x5C7, 14 /* Extend */],
    [/*start*/ 0x5C8, 0 /* Other */],
    [/*start*/ 0x5D0, 15 /* Hebrew_Letter */],
    [/*start*/ 0x5EB, 0 /* Other */],
    [/*start*/ 0x5EF, 15 /* Hebrew_Letter */],
    [/*start*/ 0x5F3, 11 /* ALetter */],
    [/*start*/ 0x5F4, 10 /* MidLetter */],
    [/*start*/ 0x5F5, 0 /* Other */],
    [/*start*/ 0x600, 13 /* Format */],
    [/*start*/ 0x606, 0 /* Other */],
    [/*start*/ 0x60C, 7 /* MidNum */],
    [/*start*/ 0x60E, 0 /* Other */],
    [/*start*/ 0x610, 14 /* Extend */],
    [/*start*/ 0x61B, 0 /* Other */],
    [/*start*/ 0x61C, 13 /* Format */],
    [/*start*/ 0x61D, 0 /* Other */],
    [/*start*/ 0x620, 11 /* ALetter */],
    [/*start*/ 0x64B, 14 /* Extend */],
    [/*start*/ 0x660, 9 /* Numeric */],
    [/*start*/ 0x66A, 0 /* Other */],
    [/*start*/ 0x66B, 9 /* Numeric */],
    [/*start*/ 0x66C, 7 /* MidNum */],
    [/*start*/ 0x66D, 0 /* Other */],
    [/*start*/ 0x66E, 11 /* ALetter */],
    [/*start*/ 0x670, 14 /* Extend */],
    [/*start*/ 0x671, 11 /* ALetter */],
    [/*start*/ 0x6D4, 0 /* Other */],
    [/*start*/ 0x6D5, 11 /* ALetter */],
    [/*start*/ 0x6D6, 14 /* Extend */],
    [/*start*/ 0x6DD, 13 /* Format */],
    [/*start*/ 0x6DE, 0 /* Other */],
    [/*start*/ 0x6DF, 14 /* Extend */],
    [/*start*/ 0x6E5, 11 /* ALetter */],
    [/*start*/ 0x6E7, 14 /* Extend */],
    [/*start*/ 0x6E9, 0 /* Other */],
    [/*start*/ 0x6EA, 14 /* Extend */],
    [/*start*/ 0x6EE, 11 /* ALetter */],
    [/*start*/ 0x6F0, 9 /* Numeric */],
    [/*start*/ 0x6FA, 11 /* ALetter */],
    [/*start*/ 0x6FD, 0 /* Other */],
    [/*start*/ 0x6FF, 11 /* ALetter */],
    [/*start*/ 0x700, 0 /* Other */],
    [/*start*/ 0x70F, 13 /* Format */],
    [/*start*/ 0x710, 11 /* ALetter */],
    [/*start*/ 0x711, 14 /* Extend */],
    [/*start*/ 0x712, 11 /* ALetter */],
    [/*start*/ 0x730, 14 /* Extend */],
    [/*start*/ 0x74B, 0 /* Other */],
    [/*start*/ 0x74D, 11 /* ALetter */],
    [/*start*/ 0x7A6, 14 /* Extend */],
    [/*start*/ 0x7B1, 11 /* ALetter */],
    [/*start*/ 0x7B2, 0 /* Other */],
    [/*start*/ 0x7C0, 9 /* Numeric */],
    [/*start*/ 0x7CA, 11 /* ALetter */],
    [/*start*/ 0x7EB, 14 /* Extend */],
    [/*start*/ 0x7F4, 11 /* ALetter */],
    [/*start*/ 0x7F6, 0 /* Other */],
    [/*start*/ 0x7F8, 7 /* MidNum */],
    [/*start*/ 0x7F9, 0 /* Other */],
    [/*start*/ 0x7FA, 11 /* ALetter */],
    [/*start*/ 0x7FB, 0 /* Other */],
    [/*start*/ 0x7FD, 14 /* Extend */],
    [/*start*/ 0x7FE, 0 /* Other */],
    [/*start*/ 0x800, 11 /* ALetter */],
    [/*start*/ 0x816, 14 /* Extend */],
    [/*start*/ 0x81A, 11 /* ALetter */],
    [/*start*/ 0x81B, 14 /* Extend */],
    [/*start*/ 0x824, 11 /* ALetter */],
    [/*start*/ 0x825, 14 /* Extend */],
    [/*start*/ 0x828, 11 /* ALetter */],
    [/*start*/ 0x829, 14 /* Extend */],
    [/*start*/ 0x82E, 0 /* Other */],
    [/*start*/ 0x840, 11 /* ALetter */],
    [/*start*/ 0x859, 14 /* Extend */],
    [/*start*/ 0x85C, 0 /* Other */],
    [/*start*/ 0x860, 11 /* ALetter */],
    [/*start*/ 0x86B, 0 /* Other */],
    [/*start*/ 0x8A0, 11 /* ALetter */],
    [/*start*/ 0x8B5, 0 /* Other */],
    [/*start*/ 0x8B6, 11 /* ALetter */],
    [/*start*/ 0x8C8, 0 /* Other */],
    [/*start*/ 0x8D3, 14 /* Extend */],
    [/*start*/ 0x8E2, 13 /* Format */],
    [/*start*/ 0x8E3, 14 /* Extend */],
    [/*start*/ 0x904, 11 /* ALetter */],
    [/*start*/ 0x93A, 14 /* Extend */],
    [/*start*/ 0x93D, 11 /* ALetter */],
    [/*start*/ 0x93E, 14 /* Extend */],
    [/*start*/ 0x950, 11 /* ALetter */],
    [/*start*/ 0x951, 14 /* Extend */],
    [/*start*/ 0x958, 11 /* ALetter */],
    [/*start*/ 0x962, 14 /* Extend */],
    [/*start*/ 0x964, 0 /* Other */],
    [/*start*/ 0x966, 9 /* Numeric */],
    [/*start*/ 0x970, 0 /* Other */],
    [/*start*/ 0x971, 11 /* ALetter */],
    [/*start*/ 0x981, 14 /* Extend */],
    [/*start*/ 0x984, 0 /* Other */],
    [/*start*/ 0x985, 11 /* ALetter */],
    [/*start*/ 0x98D, 0 /* Other */],
    [/*start*/ 0x98F, 11 /* ALetter */],
    [/*start*/ 0x991, 0 /* Other */],
    [/*start*/ 0x993, 11 /* ALetter */],
    [/*start*/ 0x9A9, 0 /* Other */],
    [/*start*/ 0x9AA, 11 /* ALetter */],
    [/*start*/ 0x9B1, 0 /* Other */],
    [/*start*/ 0x9B2, 11 /* ALetter */],
    [/*start*/ 0x9B3, 0 /* Other */],
    [/*start*/ 0x9B6, 11 /* ALetter */],
    [/*start*/ 0x9BA, 0 /* Other */],
    [/*start*/ 0x9BC, 14 /* Extend */],
    [/*start*/ 0x9BD, 11 /* ALetter */],
    [/*start*/ 0x9BE, 14 /* Extend */],
    [/*start*/ 0x9C5, 0 /* Other */],
    [/*start*/ 0x9C7, 14 /* Extend */],
    [/*start*/ 0x9C9, 0 /* Other */],
    [/*start*/ 0x9CB, 14 /* Extend */],
    [/*start*/ 0x9CE, 11 /* ALetter */],
    [/*start*/ 0x9CF, 0 /* Other */],
    [/*start*/ 0x9D7, 14 /* Extend */],
    [/*start*/ 0x9D8, 0 /* Other */],
    [/*start*/ 0x9DC, 11 /* ALetter */],
    [/*start*/ 0x9DE, 0 /* Other */],
    [/*start*/ 0x9DF, 11 /* ALetter */],
    [/*start*/ 0x9E2, 14 /* Extend */],
    [/*start*/ 0x9E4, 0 /* Other */],
    [/*start*/ 0x9E6, 9 /* Numeric */],
    [/*start*/ 0x9F0, 11 /* ALetter */],
    [/*start*/ 0x9F2, 0 /* Other */],
    [/*start*/ 0x9FC, 11 /* ALetter */],
    [/*start*/ 0x9FD, 0 /* Other */],
    [/*start*/ 0x9FE, 14 /* Extend */],
    [/*start*/ 0x9FF, 0 /* Other */],
    [/*start*/ 0xA01, 14 /* Extend */],
    [/*start*/ 0xA04, 0 /* Other */],
    [/*start*/ 0xA05, 11 /* ALetter */],
    [/*start*/ 0xA0B, 0 /* Other */],
    [/*start*/ 0xA0F, 11 /* ALetter */],
    [/*start*/ 0xA11, 0 /* Other */],
    [/*start*/ 0xA13, 11 /* ALetter */],
    [/*start*/ 0xA29, 0 /* Other */],
    [/*start*/ 0xA2A, 11 /* ALetter */],
    [/*start*/ 0xA31, 0 /* Other */],
    [/*start*/ 0xA32, 11 /* ALetter */],
    [/*start*/ 0xA34, 0 /* Other */],
    [/*start*/ 0xA35, 11 /* ALetter */],
    [/*start*/ 0xA37, 0 /* Other */],
    [/*start*/ 0xA38, 11 /* ALetter */],
    [/*start*/ 0xA3A, 0 /* Other */],
    [/*start*/ 0xA3C, 14 /* Extend */],
    [/*start*/ 0xA3D, 0 /* Other */],
    [/*start*/ 0xA3E, 14 /* Extend */],
    [/*start*/ 0xA43, 0 /* Other */],
    [/*start*/ 0xA47, 14 /* Extend */],
    [/*start*/ 0xA49, 0 /* Other */],
    [/*start*/ 0xA4B, 14 /* Extend */],
    [/*start*/ 0xA4E, 0 /* Other */],
    [/*start*/ 0xA51, 14 /* Extend */],
    [/*start*/ 0xA52, 0 /* Other */],
    [/*start*/ 0xA59, 11 /* ALetter */],
    [/*start*/ 0xA5D, 0 /* Other */],
    [/*start*/ 0xA5E, 11 /* ALetter */],
    [/*start*/ 0xA5F, 0 /* Other */],
    [/*start*/ 0xA66, 9 /* Numeric */],
    [/*start*/ 0xA70, 14 /* Extend */],
    [/*start*/ 0xA72, 11 /* ALetter */],
    [/*start*/ 0xA75, 14 /* Extend */],
    [/*start*/ 0xA76, 0 /* Other */],
    [/*start*/ 0xA81, 14 /* Extend */],
    [/*start*/ 0xA84, 0 /* Other */],
    [/*start*/ 0xA85, 11 /* ALetter */],
    [/*start*/ 0xA8E, 0 /* Other */],
    [/*start*/ 0xA8F, 11 /* ALetter */],
    [/*start*/ 0xA92, 0 /* Other */],
    [/*start*/ 0xA93, 11 /* ALetter */],
    [/*start*/ 0xAA9, 0 /* Other */],
    [/*start*/ 0xAAA, 11 /* ALetter */],
    [/*start*/ 0xAB1, 0 /* Other */],
    [/*start*/ 0xAB2, 11 /* ALetter */],
    [/*start*/ 0xAB4, 0 /* Other */],
    [/*start*/ 0xAB5, 11 /* ALetter */],
    [/*start*/ 0xABA, 0 /* Other */],
    [/*start*/ 0xABC, 14 /* Extend */],
    [/*start*/ 0xABD, 11 /* ALetter */],
    [/*start*/ 0xABE, 14 /* Extend */],
    [/*start*/ 0xAC6, 0 /* Other */],
    [/*start*/ 0xAC7, 14 /* Extend */],
    [/*start*/ 0xACA, 0 /* Other */],
    [/*start*/ 0xACB, 14 /* Extend */],
    [/*start*/ 0xACE, 0 /* Other */],
    [/*start*/ 0xAD0, 11 /* ALetter */],
    [/*start*/ 0xAD1, 0 /* Other */],
    [/*start*/ 0xAE0, 11 /* ALetter */],
    [/*start*/ 0xAE2, 14 /* Extend */],
    [/*start*/ 0xAE4, 0 /* Other */],
    [/*start*/ 0xAE6, 9 /* Numeric */],
    [/*start*/ 0xAF0, 0 /* Other */],
    [/*start*/ 0xAF9, 11 /* ALetter */],
    [/*start*/ 0xAFA, 14 /* Extend */],
    [/*start*/ 0xB00, 0 /* Other */],
    [/*start*/ 0xB01, 14 /* Extend */],
    [/*start*/ 0xB04, 0 /* Other */],
    [/*start*/ 0xB05, 11 /* ALetter */],
    [/*start*/ 0xB0D, 0 /* Other */],
    [/*start*/ 0xB0F, 11 /* ALetter */],
    [/*start*/ 0xB11, 0 /* Other */],
    [/*start*/ 0xB13, 11 /* ALetter */],
    [/*start*/ 0xB29, 0 /* Other */],
    [/*start*/ 0xB2A, 11 /* ALetter */],
    [/*start*/ 0xB31, 0 /* Other */],
    [/*start*/ 0xB32, 11 /* ALetter */],
    [/*start*/ 0xB34, 0 /* Other */],
    [/*start*/ 0xB35, 11 /* ALetter */],
    [/*start*/ 0xB3A, 0 /* Other */],
    [/*start*/ 0xB3C, 14 /* Extend */],
    [/*start*/ 0xB3D, 11 /* ALetter */],
    [/*start*/ 0xB3E, 14 /* Extend */],
    [/*start*/ 0xB45, 0 /* Other */],
    [/*start*/ 0xB47, 14 /* Extend */],
    [/*start*/ 0xB49, 0 /* Other */],
    [/*start*/ 0xB4B, 14 /* Extend */],
    [/*start*/ 0xB4E, 0 /* Other */],
    [/*start*/ 0xB55, 14 /* Extend */],
    [/*start*/ 0xB58, 0 /* Other */],
    [/*start*/ 0xB5C, 11 /* ALetter */],
    [/*start*/ 0xB5E, 0 /* Other */],
    [/*start*/ 0xB5F, 11 /* ALetter */],
    [/*start*/ 0xB62, 14 /* Extend */],
    [/*start*/ 0xB64, 0 /* Other */],
    [/*start*/ 0xB66, 9 /* Numeric */],
    [/*start*/ 0xB70, 0 /* Other */],
    [/*start*/ 0xB71, 11 /* ALetter */],
    [/*start*/ 0xB72, 0 /* Other */],
    [/*start*/ 0xB82, 14 /* Extend */],
    [/*start*/ 0xB83, 11 /* ALetter */],
    [/*start*/ 0xB84, 0 /* Other */],
    [/*start*/ 0xB85, 11 /* ALetter */],
    [/*start*/ 0xB8B, 0 /* Other */],
    [/*start*/ 0xB8E, 11 /* ALetter */],
    [/*start*/ 0xB91, 0 /* Other */],
    [/*start*/ 0xB92, 11 /* ALetter */],
    [/*start*/ 0xB96, 0 /* Other */],
    [/*start*/ 0xB99, 11 /* ALetter */],
    [/*start*/ 0xB9B, 0 /* Other */],
    [/*start*/ 0xB9C, 11 /* ALetter */],
    [/*start*/ 0xB9D, 0 /* Other */],
    [/*start*/ 0xB9E, 11 /* ALetter */],
    [/*start*/ 0xBA0, 0 /* Other */],
    [/*start*/ 0xBA3, 11 /* ALetter */],
    [/*start*/ 0xBA5, 0 /* Other */],
    [/*start*/ 0xBA8, 11 /* ALetter */],
    [/*start*/ 0xBAB, 0 /* Other */],
    [/*start*/ 0xBAE, 11 /* ALetter */],
    [/*start*/ 0xBBA, 0 /* Other */],
    [/*start*/ 0xBBE, 14 /* Extend */],
    [/*start*/ 0xBC3, 0 /* Other */],
    [/*start*/ 0xBC6, 14 /* Extend */],
    [/*start*/ 0xBC9, 0 /* Other */],
    [/*start*/ 0xBCA, 14 /* Extend */],
    [/*start*/ 0xBCE, 0 /* Other */],
    [/*start*/ 0xBD0, 11 /* ALetter */],
    [/*start*/ 0xBD1, 0 /* Other */],
    [/*start*/ 0xBD7, 14 /* Extend */],
    [/*start*/ 0xBD8, 0 /* Other */],
    [/*start*/ 0xBE6, 9 /* Numeric */],
    [/*start*/ 0xBF0, 0 /* Other */],
    [/*start*/ 0xC00, 14 /* Extend */],
    [/*start*/ 0xC05, 11 /* ALetter */],
    [/*start*/ 0xC0D, 0 /* Other */],
    [/*start*/ 0xC0E, 11 /* ALetter */],
    [/*start*/ 0xC11, 0 /* Other */],
    [/*start*/ 0xC12, 11 /* ALetter */],
    [/*start*/ 0xC29, 0 /* Other */],
    [/*start*/ 0xC2A, 11 /* ALetter */],
    [/*start*/ 0xC3A, 0 /* Other */],
    [/*start*/ 0xC3D, 11 /* ALetter */],
    [/*start*/ 0xC3E, 14 /* Extend */],
    [/*start*/ 0xC45, 0 /* Other */],
    [/*start*/ 0xC46, 14 /* Extend */],
    [/*start*/ 0xC49, 0 /* Other */],
    [/*start*/ 0xC4A, 14 /* Extend */],
    [/*start*/ 0xC4E, 0 /* Other */],
    [/*start*/ 0xC55, 14 /* Extend */],
    [/*start*/ 0xC57, 0 /* Other */],
    [/*start*/ 0xC58, 11 /* ALetter */],
    [/*start*/ 0xC5B, 0 /* Other */],
    [/*start*/ 0xC60, 11 /* ALetter */],
    [/*start*/ 0xC62, 14 /* Extend */],
    [/*start*/ 0xC64, 0 /* Other */],
    [/*start*/ 0xC66, 9 /* Numeric */],
    [/*start*/ 0xC70, 0 /* Other */],
    [/*start*/ 0xC80, 11 /* ALetter */],
    [/*start*/ 0xC81, 14 /* Extend */],
    [/*start*/ 0xC84, 0 /* Other */],
    [/*start*/ 0xC85, 11 /* ALetter */],
    [/*start*/ 0xC8D, 0 /* Other */],
    [/*start*/ 0xC8E, 11 /* ALetter */],
    [/*start*/ 0xC91, 0 /* Other */],
    [/*start*/ 0xC92, 11 /* ALetter */],
    [/*start*/ 0xCA9, 0 /* Other */],
    [/*start*/ 0xCAA, 11 /* ALetter */],
    [/*start*/ 0xCB4, 0 /* Other */],
    [/*start*/ 0xCB5, 11 /* ALetter */],
    [/*start*/ 0xCBA, 0 /* Other */],
    [/*start*/ 0xCBC, 14 /* Extend */],
    [/*start*/ 0xCBD, 11 /* ALetter */],
    [/*start*/ 0xCBE, 14 /* Extend */],
    [/*start*/ 0xCC5, 0 /* Other */],
    [/*start*/ 0xCC6, 14 /* Extend */],
    [/*start*/ 0xCC9, 0 /* Other */],
    [/*start*/ 0xCCA, 14 /* Extend */],
    [/*start*/ 0xCCE, 0 /* Other */],
    [/*start*/ 0xCD5, 14 /* Extend */],
    [/*start*/ 0xCD7, 0 /* Other */],
    [/*start*/ 0xCDE, 11 /* ALetter */],
    [/*start*/ 0xCDF, 0 /* Other */],
    [/*start*/ 0xCE0, 11 /* ALetter */],
    [/*start*/ 0xCE2, 14 /* Extend */],
    [/*start*/ 0xCE4, 0 /* Other */],
    [/*start*/ 0xCE6, 9 /* Numeric */],
    [/*start*/ 0xCF0, 0 /* Other */],
    [/*start*/ 0xCF1, 11 /* ALetter */],
    [/*start*/ 0xCF3, 0 /* Other */],
    [/*start*/ 0xD00, 14 /* Extend */],
    [/*start*/ 0xD04, 11 /* ALetter */],
    [/*start*/ 0xD0D, 0 /* Other */],
    [/*start*/ 0xD0E, 11 /* ALetter */],
    [/*start*/ 0xD11, 0 /* Other */],
    [/*start*/ 0xD12, 11 /* ALetter */],
    [/*start*/ 0xD3B, 14 /* Extend */],
    [/*start*/ 0xD3D, 11 /* ALetter */],
    [/*start*/ 0xD3E, 14 /* Extend */],
    [/*start*/ 0xD45, 0 /* Other */],
    [/*start*/ 0xD46, 14 /* Extend */],
    [/*start*/ 0xD49, 0 /* Other */],
    [/*start*/ 0xD4A, 14 /* Extend */],
    [/*start*/ 0xD4E, 11 /* ALetter */],
    [/*start*/ 0xD4F, 0 /* Other */],
    [/*start*/ 0xD54, 11 /* ALetter */],
    [/*start*/ 0xD57, 14 /* Extend */],
    [/*start*/ 0xD58, 0 /* Other */],
    [/*start*/ 0xD5F, 11 /* ALetter */],
    [/*start*/ 0xD62, 14 /* Extend */],
    [/*start*/ 0xD64, 0 /* Other */],
    [/*start*/ 0xD66, 9 /* Numeric */],
    [/*start*/ 0xD70, 0 /* Other */],
    [/*start*/ 0xD7A, 11 /* ALetter */],
    [/*start*/ 0xD80, 0 /* Other */],
    [/*start*/ 0xD81, 14 /* Extend */],
    [/*start*/ 0xD84, 0 /* Other */],
    [/*start*/ 0xD85, 11 /* ALetter */],
    [/*start*/ 0xD97, 0 /* Other */],
    [/*start*/ 0xD9A, 11 /* ALetter */],
    [/*start*/ 0xDB2, 0 /* Other */],
    [/*start*/ 0xDB3, 11 /* ALetter */],
    [/*start*/ 0xDBC, 0 /* Other */],
    [/*start*/ 0xDBD, 11 /* ALetter */],
    [/*start*/ 0xDBE, 0 /* Other */],
    [/*start*/ 0xDC0, 11 /* ALetter */],
    [/*start*/ 0xDC7, 0 /* Other */],
    [/*start*/ 0xDCA, 14 /* Extend */],
    [/*start*/ 0xDCB, 0 /* Other */],
    [/*start*/ 0xDCF, 14 /* Extend */],
    [/*start*/ 0xDD5, 0 /* Other */],
    [/*start*/ 0xDD6, 14 /* Extend */],
    [/*start*/ 0xDD7, 0 /* Other */],
    [/*start*/ 0xDD8, 14 /* Extend */],
    [/*start*/ 0xDE0, 0 /* Other */],
    [/*start*/ 0xDE6, 9 /* Numeric */],
    [/*start*/ 0xDF0, 0 /* Other */],
    [/*start*/ 0xDF2, 14 /* Extend */],
    [/*start*/ 0xDF4, 0 /* Other */],
    [/*start*/ 0xE31, 14 /* Extend */],
    [/*start*/ 0xE32, 0 /* Other */],
    [/*start*/ 0xE34, 14 /* Extend */],
    [/*start*/ 0xE3B, 0 /* Other */],
    [/*start*/ 0xE47, 14 /* Extend */],
    [/*start*/ 0xE4F, 0 /* Other */],
    [/*start*/ 0xE50, 9 /* Numeric */],
    [/*start*/ 0xE5A, 0 /* Other */],
    [/*start*/ 0xEB1, 14 /* Extend */],
    [/*start*/ 0xEB2, 0 /* Other */],
    [/*start*/ 0xEB4, 14 /* Extend */],
    [/*start*/ 0xEBD, 0 /* Other */],
    [/*start*/ 0xEC8, 14 /* Extend */],
    [/*start*/ 0xECE, 0 /* Other */],
    [/*start*/ 0xED0, 9 /* Numeric */],
    [/*start*/ 0xEDA, 0 /* Other */],
    [/*start*/ 0xF00, 11 /* ALetter */],
    [/*start*/ 0xF01, 0 /* Other */],
    [/*start*/ 0xF18, 14 /* Extend */],
    [/*start*/ 0xF1A, 0 /* Other */],
    [/*start*/ 0xF20, 9 /* Numeric */],
    [/*start*/ 0xF2A, 0 /* Other */],
    [/*start*/ 0xF35, 14 /* Extend */],
    [/*start*/ 0xF36, 0 /* Other */],
    [/*start*/ 0xF37, 14 /* Extend */],
    [/*start*/ 0xF38, 0 /* Other */],
    [/*start*/ 0xF39, 14 /* Extend */],
    [/*start*/ 0xF3A, 0 /* Other */],
    [/*start*/ 0xF3E, 14 /* Extend */],
    [/*start*/ 0xF40, 11 /* ALetter */],
    [/*start*/ 0xF48, 0 /* Other */],
    [/*start*/ 0xF49, 11 /* ALetter */],
    [/*start*/ 0xF6D, 0 /* Other */],
    [/*start*/ 0xF71, 14 /* Extend */],
    [/*start*/ 0xF85, 0 /* Other */],
    [/*start*/ 0xF86, 14 /* Extend */],
    [/*start*/ 0xF88, 11 /* ALetter */],
    [/*start*/ 0xF8D, 14 /* Extend */],
    [/*start*/ 0xF98, 0 /* Other */],
    [/*start*/ 0xF99, 14 /* Extend */],
    [/*start*/ 0xFBD, 0 /* Other */],
    [/*start*/ 0xFC6, 14 /* Extend */],
    [/*start*/ 0xFC7, 0 /* Other */],
    [/*start*/ 0x102B, 14 /* Extend */],
    [/*start*/ 0x103F, 0 /* Other */],
    [/*start*/ 0x1040, 9 /* Numeric */],
    [/*start*/ 0x104A, 0 /* Other */],
    [/*start*/ 0x1056, 14 /* Extend */],
    [/*start*/ 0x105A, 0 /* Other */],
    [/*start*/ 0x105E, 14 /* Extend */],
    [/*start*/ 0x1061, 0 /* Other */],
    [/*start*/ 0x1062, 14 /* Extend */],
    [/*start*/ 0x1065, 0 /* Other */],
    [/*start*/ 0x1067, 14 /* Extend */],
    [/*start*/ 0x106E, 0 /* Other */],
    [/*start*/ 0x1071, 14 /* Extend */],
    [/*start*/ 0x1075, 0 /* Other */],
    [/*start*/ 0x1082, 14 /* Extend */],
    [/*start*/ 0x108E, 0 /* Other */],
    [/*start*/ 0x108F, 14 /* Extend */],
    [/*start*/ 0x1090, 9 /* Numeric */],
    [/*start*/ 0x109A, 14 /* Extend */],
    [/*start*/ 0x109E, 0 /* Other */],
    [/*start*/ 0x10A0, 11 /* ALetter */],
    [/*start*/ 0x10C6, 0 /* Other */],
    [/*start*/ 0x10C7, 11 /* ALetter */],
    [/*start*/ 0x10C8, 0 /* Other */],
    [/*start*/ 0x10CD, 11 /* ALetter */],
    [/*start*/ 0x10CE, 0 /* Other */],
    [/*start*/ 0x10D0, 11 /* ALetter */],
    [/*start*/ 0x10FB, 0 /* Other */],
    [/*start*/ 0x10FC, 11 /* ALetter */],
    [/*start*/ 0x1249, 0 /* Other */],
    [/*start*/ 0x124A, 11 /* ALetter */],
    [/*start*/ 0x124E, 0 /* Other */],
    [/*start*/ 0x1250, 11 /* ALetter */],
    [/*start*/ 0x1257, 0 /* Other */],
    [/*start*/ 0x1258, 11 /* ALetter */],
    [/*start*/ 0x1259, 0 /* Other */],
    [/*start*/ 0x125A, 11 /* ALetter */],
    [/*start*/ 0x125E, 0 /* Other */],
    [/*start*/ 0x1260, 11 /* ALetter */],
    [/*start*/ 0x1289, 0 /* Other */],
    [/*start*/ 0x128A, 11 /* ALetter */],
    [/*start*/ 0x128E, 0 /* Other */],
    [/*start*/ 0x1290, 11 /* ALetter */],
    [/*start*/ 0x12B1, 0 /* Other */],
    [/*start*/ 0x12B2, 11 /* ALetter */],
    [/*start*/ 0x12B6, 0 /* Other */],
    [/*start*/ 0x12B8, 11 /* ALetter */],
    [/*start*/ 0x12BF, 0 /* Other */],
    [/*start*/ 0x12C0, 11 /* ALetter */],
    [/*start*/ 0x12C1, 0 /* Other */],
    [/*start*/ 0x12C2, 11 /* ALetter */],
    [/*start*/ 0x12C6, 0 /* Other */],
    [/*start*/ 0x12C8, 11 /* ALetter */],
    [/*start*/ 0x12D7, 0 /* Other */],
    [/*start*/ 0x12D8, 11 /* ALetter */],
    [/*start*/ 0x1311, 0 /* Other */],
    [/*start*/ 0x1312, 11 /* ALetter */],
    [/*start*/ 0x1316, 0 /* Other */],
    [/*start*/ 0x1318, 11 /* ALetter */],
    [/*start*/ 0x135B, 0 /* Other */],
    [/*start*/ 0x135D, 14 /* Extend */],
    [/*start*/ 0x1360, 0 /* Other */],
    [/*start*/ 0x1380, 11 /* ALetter */],
    [/*start*/ 0x1390, 0 /* Other */],
    [/*start*/ 0x13A0, 11 /* ALetter */],
    [/*start*/ 0x13F6, 0 /* Other */],
    [/*start*/ 0x13F8, 11 /* ALetter */],
    [/*start*/ 0x13FE, 0 /* Other */],
    [/*start*/ 0x1401, 11 /* ALetter */],
    [/*start*/ 0x166D, 0 /* Other */],
    [/*start*/ 0x166F, 11 /* ALetter */],
    [/*start*/ 0x1680, 4 /* WSegSpace */],
    [/*start*/ 0x1681, 11 /* ALetter */],
    [/*start*/ 0x169B, 0 /* Other */],
    [/*start*/ 0x16A0, 11 /* ALetter */],
    [/*start*/ 0x16EB, 0 /* Other */],
    [/*start*/ 0x16EE, 11 /* ALetter */],
    [/*start*/ 0x16F9, 0 /* Other */],
    [/*start*/ 0x1700, 11 /* ALetter */],
    [/*start*/ 0x170D, 0 /* Other */],
    [/*start*/ 0x170E, 11 /* ALetter */],
    [/*start*/ 0x1712, 14 /* Extend */],
    [/*start*/ 0x1715, 0 /* Other */],
    [/*start*/ 0x1720, 11 /* ALetter */],
    [/*start*/ 0x1732, 14 /* Extend */],
    [/*start*/ 0x1735, 0 /* Other */],
    [/*start*/ 0x1740, 11 /* ALetter */],
    [/*start*/ 0x1752, 14 /* Extend */],
    [/*start*/ 0x1754, 0 /* Other */],
    [/*start*/ 0x1760, 11 /* ALetter */],
    [/*start*/ 0x176D, 0 /* Other */],
    [/*start*/ 0x176E, 11 /* ALetter */],
    [/*start*/ 0x1771, 0 /* Other */],
    [/*start*/ 0x1772, 14 /* Extend */],
    [/*start*/ 0x1774, 0 /* Other */],
    [/*start*/ 0x17B4, 14 /* Extend */],
    [/*start*/ 0x17D4, 0 /* Other */],
    [/*start*/ 0x17DD, 14 /* Extend */],
    [/*start*/ 0x17DE, 0 /* Other */],
    [/*start*/ 0x17E0, 9 /* Numeric */],
    [/*start*/ 0x17EA, 0 /* Other */],
    [/*start*/ 0x180B, 14 /* Extend */],
    [/*start*/ 0x180E, 13 /* Format */],
    [/*start*/ 0x180F, 0 /* Other */],
    [/*start*/ 0x1810, 9 /* Numeric */],
    [/*start*/ 0x181A, 0 /* Other */],
    [/*start*/ 0x1820, 11 /* ALetter */],
    [/*start*/ 0x1879, 0 /* Other */],
    [/*start*/ 0x1880, 11 /* ALetter */],
    [/*start*/ 0x1885, 14 /* Extend */],
    [/*start*/ 0x1887, 11 /* ALetter */],
    [/*start*/ 0x18A9, 14 /* Extend */],
    [/*start*/ 0x18AA, 11 /* ALetter */],
    [/*start*/ 0x18AB, 0 /* Other */],
    [/*start*/ 0x18B0, 11 /* ALetter */],
    [/*start*/ 0x18F6, 0 /* Other */],
    [/*start*/ 0x1900, 11 /* ALetter */],
    [/*start*/ 0x191F, 0 /* Other */],
    [/*start*/ 0x1920, 14 /* Extend */],
    [/*start*/ 0x192C, 0 /* Other */],
    [/*start*/ 0x1930, 14 /* Extend */],
    [/*start*/ 0x193C, 0 /* Other */],
    [/*start*/ 0x1946, 9 /* Numeric */],
    [/*start*/ 0x1950, 0 /* Other */],
    [/*start*/ 0x19D0, 9 /* Numeric */],
    [/*start*/ 0x19DA, 0 /* Other */],
    [/*start*/ 0x1A00, 11 /* ALetter */],
    [/*start*/ 0x1A17, 14 /* Extend */],
    [/*start*/ 0x1A1C, 0 /* Other */],
    [/*start*/ 0x1A55, 14 /* Extend */],
    [/*start*/ 0x1A5F, 0 /* Other */],
    [/*start*/ 0x1A60, 14 /* Extend */],
    [/*start*/ 0x1A7D, 0 /* Other */],
    [/*start*/ 0x1A7F, 14 /* Extend */],
    [/*start*/ 0x1A80, 9 /* Numeric */],
    [/*start*/ 0x1A8A, 0 /* Other */],
    [/*start*/ 0x1A90, 9 /* Numeric */],
    [/*start*/ 0x1A9A, 0 /* Other */],
    [/*start*/ 0x1AB0, 14 /* Extend */],
    [/*start*/ 0x1AC1, 0 /* Other */],
    [/*start*/ 0x1B00, 14 /* Extend */],
    [/*start*/ 0x1B05, 11 /* ALetter */],
    [/*start*/ 0x1B34, 14 /* Extend */],
    [/*start*/ 0x1B45, 11 /* ALetter */],
    [/*start*/ 0x1B4C, 0 /* Other */],
    [/*start*/ 0x1B50, 9 /* Numeric */],
    [/*start*/ 0x1B5A, 0 /* Other */],
    [/*start*/ 0x1B6B, 14 /* Extend */],
    [/*start*/ 0x1B74, 0 /* Other */],
    [/*start*/ 0x1B80, 14 /* Extend */],
    [/*start*/ 0x1B83, 11 /* ALetter */],
    [/*start*/ 0x1BA1, 14 /* Extend */],
    [/*start*/ 0x1BAE, 11 /* ALetter */],
    [/*start*/ 0x1BB0, 9 /* Numeric */],
    [/*start*/ 0x1BBA, 11 /* ALetter */],
    [/*start*/ 0x1BE6, 14 /* Extend */],
    [/*start*/ 0x1BF4, 0 /* Other */],
    [/*start*/ 0x1C00, 11 /* ALetter */],
    [/*start*/ 0x1C24, 14 /* Extend */],
    [/*start*/ 0x1C38, 0 /* Other */],
    [/*start*/ 0x1C40, 9 /* Numeric */],
    [/*start*/ 0x1C4A, 0 /* Other */],
    [/*start*/ 0x1C4D, 11 /* ALetter */],
    [/*start*/ 0x1C50, 9 /* Numeric */],
    [/*start*/ 0x1C5A, 11 /* ALetter */],
    [/*start*/ 0x1C7E, 0 /* Other */],
    [/*start*/ 0x1C80, 11 /* ALetter */],
    [/*start*/ 0x1C89, 0 /* Other */],
    [/*start*/ 0x1C90, 11 /* ALetter */],
    [/*start*/ 0x1CBB, 0 /* Other */],
    [/*start*/ 0x1CBD, 11 /* ALetter */],
    [/*start*/ 0x1CC0, 0 /* Other */],
    [/*start*/ 0x1CD0, 14 /* Extend */],
    [/*start*/ 0x1CD3, 0 /* Other */],
    [/*start*/ 0x1CD4, 14 /* Extend */],
    [/*start*/ 0x1CE9, 11 /* ALetter */],
    [/*start*/ 0x1CED, 14 /* Extend */],
    [/*start*/ 0x1CEE, 11 /* ALetter */],
    [/*start*/ 0x1CF4, 14 /* Extend */],
    [/*start*/ 0x1CF5, 11 /* ALetter */],
    [/*start*/ 0x1CF7, 14 /* Extend */],
    [/*start*/ 0x1CFA, 11 /* ALetter */],
    [/*start*/ 0x1CFB, 0 /* Other */],
    [/*start*/ 0x1D00, 11 /* ALetter */],
    [/*start*/ 0x1DC0, 14 /* Extend */],
    [/*start*/ 0x1DFA, 0 /* Other */],
    [/*start*/ 0x1DFB, 14 /* Extend */],
    [/*start*/ 0x1E00, 11 /* ALetter */],
    [/*start*/ 0x1F16, 0 /* Other */],
    [/*start*/ 0x1F18, 11 /* ALetter */],
    [/*start*/ 0x1F1E, 0 /* Other */],
    [/*start*/ 0x1F20, 11 /* ALetter */],
    [/*start*/ 0x1F46, 0 /* Other */],
    [/*start*/ 0x1F48, 11 /* ALetter */],
    [/*start*/ 0x1F4E, 0 /* Other */],
    [/*start*/ 0x1F50, 11 /* ALetter */],
    [/*start*/ 0x1F58, 0 /* Other */],
    [/*start*/ 0x1F59, 11 /* ALetter */],
    [/*start*/ 0x1F5A, 0 /* Other */],
    [/*start*/ 0x1F5B, 11 /* ALetter */],
    [/*start*/ 0x1F5C, 0 /* Other */],
    [/*start*/ 0x1F5D, 11 /* ALetter */],
    [/*start*/ 0x1F5E, 0 /* Other */],
    [/*start*/ 0x1F5F, 11 /* ALetter */],
    [/*start*/ 0x1F7E, 0 /* Other */],
    [/*start*/ 0x1F80, 11 /* ALetter */],
    [/*start*/ 0x1FB5, 0 /* Other */],
    [/*start*/ 0x1FB6, 11 /* ALetter */],
    [/*start*/ 0x1FBD, 0 /* Other */],
    [/*start*/ 0x1FBE, 11 /* ALetter */],
    [/*start*/ 0x1FBF, 0 /* Other */],
    [/*start*/ 0x1FC2, 11 /* ALetter */],
    [/*start*/ 0x1FC5, 0 /* Other */],
    [/*start*/ 0x1FC6, 11 /* ALetter */],
    [/*start*/ 0x1FCD, 0 /* Other */],
    [/*start*/ 0x1FD0, 11 /* ALetter */],
    [/*start*/ 0x1FD4, 0 /* Other */],
    [/*start*/ 0x1FD6, 11 /* ALetter */],
    [/*start*/ 0x1FDC, 0 /* Other */],
    [/*start*/ 0x1FE0, 11 /* ALetter */],
    [/*start*/ 0x1FED, 0 /* Other */],
    [/*start*/ 0x1FF2, 11 /* ALetter */],
    [/*start*/ 0x1FF5, 0 /* Other */],
    [/*start*/ 0x1FF6, 11 /* ALetter */],
    [/*start*/ 0x1FFD, 0 /* Other */],
    [/*start*/ 0x2000, 4 /* WSegSpace */],
    [/*start*/ 0x2007, 0 /* Other */],
    [/*start*/ 0x2008, 4 /* WSegSpace */],
    [/*start*/ 0x200B, 0 /* Other */],
    [/*start*/ 0x200C, 14 /* Extend */],
    [/*start*/ 0x200D, 16 /* ZWJ */],
    [/*start*/ 0x200E, 13 /* Format */],
    [/*start*/ 0x2010, 0 /* Other */],
    [/*start*/ 0x2018, 8 /* MidNumLet */],
    [/*start*/ 0x201A, 0 /* Other */],
    [/*start*/ 0x2024, 8 /* MidNumLet */],
    [/*start*/ 0x2025, 0 /* Other */],
    [/*start*/ 0x2027, 10 /* MidLetter */],
    [/*start*/ 0x2028, 2 /* Newline */],
    [/*start*/ 0x202A, 13 /* Format */],
    [/*start*/ 0x202F, 12 /* ExtendNumLet */],
    [/*start*/ 0x2030, 0 /* Other */],
    [/*start*/ 0x203F, 12 /* ExtendNumLet */],
    [/*start*/ 0x2041, 0 /* Other */],
    [/*start*/ 0x2044, 7 /* MidNum */],
    [/*start*/ 0x2045, 0 /* Other */],
    [/*start*/ 0x2054, 12 /* ExtendNumLet */],
    [/*start*/ 0x2055, 0 /* Other */],
    [/*start*/ 0x205F, 4 /* WSegSpace */],
    [/*start*/ 0x2060, 13 /* Format */],
    [/*start*/ 0x2065, 0 /* Other */],
    [/*start*/ 0x2066, 13 /* Format */],
    [/*start*/ 0x2070, 0 /* Other */],
    [/*start*/ 0x2071, 11 /* ALetter */],
    [/*start*/ 0x2072, 0 /* Other */],
    [/*start*/ 0x207F, 11 /* ALetter */],
    [/*start*/ 0x2080, 0 /* Other */],
    [/*start*/ 0x2090, 11 /* ALetter */],
    [/*start*/ 0x209D, 0 /* Other */],
    [/*start*/ 0x20D0, 14 /* Extend */],
    [/*start*/ 0x20F1, 0 /* Other */],
    [/*start*/ 0x2102, 11 /* ALetter */],
    [/*start*/ 0x2103, 0 /* Other */],
    [/*start*/ 0x2107, 11 /* ALetter */],
    [/*start*/ 0x2108, 0 /* Other */],
    [/*start*/ 0x210A, 11 /* ALetter */],
    [/*start*/ 0x2114, 0 /* Other */],
    [/*start*/ 0x2115, 11 /* ALetter */],
    [/*start*/ 0x2116, 0 /* Other */],
    [/*start*/ 0x2119, 11 /* ALetter */],
    [/*start*/ 0x211E, 0 /* Other */],
    [/*start*/ 0x2124, 11 /* ALetter */],
    [/*start*/ 0x2125, 0 /* Other */],
    [/*start*/ 0x2126, 11 /* ALetter */],
    [/*start*/ 0x2127, 0 /* Other */],
    [/*start*/ 0x2128, 11 /* ALetter */],
    [/*start*/ 0x2129, 0 /* Other */],
    [/*start*/ 0x212A, 11 /* ALetter */],
    [/*start*/ 0x212E, 0 /* Other */],
    [/*start*/ 0x212F, 11 /* ALetter */],
    [/*start*/ 0x213A, 0 /* Other */],
    [/*start*/ 0x213C, 11 /* ALetter */],
    [/*start*/ 0x2140, 0 /* Other */],
    [/*start*/ 0x2145, 11 /* ALetter */],
    [/*start*/ 0x214A, 0 /* Other */],
    [/*start*/ 0x214E, 11 /* ALetter */],
    [/*start*/ 0x214F, 0 /* Other */],
    [/*start*/ 0x2160, 11 /* ALetter */],
    [/*start*/ 0x2189, 0 /* Other */],
    [/*start*/ 0x24B6, 11 /* ALetter */],
    [/*start*/ 0x24EA, 0 /* Other */],
    [/*start*/ 0x2C00, 11 /* ALetter */],
    [/*start*/ 0x2C2F, 0 /* Other */],
    [/*start*/ 0x2C30, 11 /* ALetter */],
    [/*start*/ 0x2C5F, 0 /* Other */],
    [/*start*/ 0x2C60, 11 /* ALetter */],
    [/*start*/ 0x2CE5, 0 /* Other */],
    [/*start*/ 0x2CEB, 11 /* ALetter */],
    [/*start*/ 0x2CEF, 14 /* Extend */],
    [/*start*/ 0x2CF2, 11 /* ALetter */],
    [/*start*/ 0x2CF4, 0 /* Other */],
    [/*start*/ 0x2D00, 11 /* ALetter */],
    [/*start*/ 0x2D26, 0 /* Other */],
    [/*start*/ 0x2D27, 11 /* ALetter */],
    [/*start*/ 0x2D28, 0 /* Other */],
    [/*start*/ 0x2D2D, 11 /* ALetter */],
    [/*start*/ 0x2D2E, 0 /* Other */],
    [/*start*/ 0x2D30, 11 /* ALetter */],
    [/*start*/ 0x2D68, 0 /* Other */],
    [/*start*/ 0x2D6F, 11 /* ALetter */],
    [/*start*/ 0x2D70, 0 /* Other */],
    [/*start*/ 0x2D7F, 14 /* Extend */],
    [/*start*/ 0x2D80, 11 /* ALetter */],
    [/*start*/ 0x2D97, 0 /* Other */],
    [/*start*/ 0x2DA0, 11 /* ALetter */],
    [/*start*/ 0x2DA7, 0 /* Other */],
    [/*start*/ 0x2DA8, 11 /* ALetter */],
    [/*start*/ 0x2DAF, 0 /* Other */],
    [/*start*/ 0x2DB0, 11 /* ALetter */],
    [/*start*/ 0x2DB7, 0 /* Other */],
    [/*start*/ 0x2DB8, 11 /* ALetter */],
    [/*start*/ 0x2DBF, 0 /* Other */],
    [/*start*/ 0x2DC0, 11 /* ALetter */],
    [/*start*/ 0x2DC7, 0 /* Other */],
    [/*start*/ 0x2DC8, 11 /* ALetter */],
    [/*start*/ 0x2DCF, 0 /* Other */],
    [/*start*/ 0x2DD0, 11 /* ALetter */],
    [/*start*/ 0x2DD7, 0 /* Other */],
    [/*start*/ 0x2DD8, 11 /* ALetter */],
    [/*start*/ 0x2DDF, 0 /* Other */],
    [/*start*/ 0x2DE0, 14 /* Extend */],
    [/*start*/ 0x2E00, 0 /* Other */],
    [/*start*/ 0x2E2F, 11 /* ALetter */],
    [/*start*/ 0x2E30, 0 /* Other */],
    [/*start*/ 0x3000, 4 /* WSegSpace */],
    [/*start*/ 0x3001, 0 /* Other */],
    [/*start*/ 0x3005, 11 /* ALetter */],
    [/*start*/ 0x3006, 0 /* Other */],
    [/*start*/ 0x302A, 14 /* Extend */],
    [/*start*/ 0x3030, 0 /* Other */],
    [/*start*/ 0x3031, 17 /* Katakana */],
    [/*start*/ 0x3036, 0 /* Other */],
    [/*start*/ 0x303B, 11 /* ALetter */],
    [/*start*/ 0x303D, 0 /* Other */],
    [/*start*/ 0x3099, 14 /* Extend */],
    [/*start*/ 0x309B, 17 /* Katakana */],
    [/*start*/ 0x309D, 0 /* Other */],
    [/*start*/ 0x30A0, 17 /* Katakana */],
    [/*start*/ 0x30FB, 0 /* Other */],
    [/*start*/ 0x30FC, 17 /* Katakana */],
    [/*start*/ 0x3100, 0 /* Other */],
    [/*start*/ 0x3105, 11 /* ALetter */],
    [/*start*/ 0x3130, 0 /* Other */],
    [/*start*/ 0x3131, 11 /* ALetter */],
    [/*start*/ 0x318F, 0 /* Other */],
    [/*start*/ 0x31A0, 11 /* ALetter */],
    [/*start*/ 0x31C0, 0 /* Other */],
    [/*start*/ 0x31F0, 17 /* Katakana */],
    [/*start*/ 0x3200, 0 /* Other */],
    [/*start*/ 0x32D0, 17 /* Katakana */],
    [/*start*/ 0x32FF, 0 /* Other */],
    [/*start*/ 0x3300, 17 /* Katakana */],
    [/*start*/ 0x3358, 0 /* Other */],
    [/*start*/ 0xA000, 11 /* ALetter */],
    [/*start*/ 0xA48D, 0 /* Other */],
    [/*start*/ 0xA4D0, 11 /* ALetter */],
    [/*start*/ 0xA4FE, 0 /* Other */],
    [/*start*/ 0xA500, 11 /* ALetter */],
    [/*start*/ 0xA60D, 0 /* Other */],
    [/*start*/ 0xA610, 11 /* ALetter */],
    [/*start*/ 0xA620, 9 /* Numeric */],
    [/*start*/ 0xA62A, 11 /* ALetter */],
    [/*start*/ 0xA62C, 0 /* Other */],
    [/*start*/ 0xA640, 11 /* ALetter */],
    [/*start*/ 0xA66F, 14 /* Extend */],
    [/*start*/ 0xA673, 0 /* Other */],
    [/*start*/ 0xA674, 14 /* Extend */],
    [/*start*/ 0xA67E, 0 /* Other */],
    [/*start*/ 0xA67F, 11 /* ALetter */],
    [/*start*/ 0xA69E, 14 /* Extend */],
    [/*start*/ 0xA6A0, 11 /* ALetter */],
    [/*start*/ 0xA6F0, 14 /* Extend */],
    [/*start*/ 0xA6F2, 0 /* Other */],
    [/*start*/ 0xA708, 11 /* ALetter */],
    [/*start*/ 0xA7C0, 0 /* Other */],
    [/*start*/ 0xA7C2, 11 /* ALetter */],
    [/*start*/ 0xA7CB, 0 /* Other */],
    [/*start*/ 0xA7F5, 11 /* ALetter */],
    [/*start*/ 0xA802, 14 /* Extend */],
    [/*start*/ 0xA803, 11 /* ALetter */],
    [/*start*/ 0xA806, 14 /* Extend */],
    [/*start*/ 0xA807, 11 /* ALetter */],
    [/*start*/ 0xA80B, 14 /* Extend */],
    [/*start*/ 0xA80C, 11 /* ALetter */],
    [/*start*/ 0xA823, 14 /* Extend */],
    [/*start*/ 0xA828, 0 /* Other */],
    [/*start*/ 0xA82C, 14 /* Extend */],
    [/*start*/ 0xA82D, 0 /* Other */],
    [/*start*/ 0xA840, 11 /* ALetter */],
    [/*start*/ 0xA874, 0 /* Other */],
    [/*start*/ 0xA880, 14 /* Extend */],
    [/*start*/ 0xA882, 11 /* ALetter */],
    [/*start*/ 0xA8B4, 14 /* Extend */],
    [/*start*/ 0xA8C6, 0 /* Other */],
    [/*start*/ 0xA8D0, 9 /* Numeric */],
    [/*start*/ 0xA8DA, 0 /* Other */],
    [/*start*/ 0xA8E0, 14 /* Extend */],
    [/*start*/ 0xA8F2, 11 /* ALetter */],
    [/*start*/ 0xA8F8, 0 /* Other */],
    [/*start*/ 0xA8FB, 11 /* ALetter */],
    [/*start*/ 0xA8FC, 0 /* Other */],
    [/*start*/ 0xA8FD, 11 /* ALetter */],
    [/*start*/ 0xA8FF, 14 /* Extend */],
    [/*start*/ 0xA900, 9 /* Numeric */],
    [/*start*/ 0xA90A, 11 /* ALetter */],
    [/*start*/ 0xA926, 14 /* Extend */],
    [/*start*/ 0xA92E, 0 /* Other */],
    [/*start*/ 0xA930, 11 /* ALetter */],
    [/*start*/ 0xA947, 14 /* Extend */],
    [/*start*/ 0xA954, 0 /* Other */],
    [/*start*/ 0xA960, 11 /* ALetter */],
    [/*start*/ 0xA97D, 0 /* Other */],
    [/*start*/ 0xA980, 14 /* Extend */],
    [/*start*/ 0xA984, 11 /* ALetter */],
    [/*start*/ 0xA9B3, 14 /* Extend */],
    [/*start*/ 0xA9C1, 0 /* Other */],
    [/*start*/ 0xA9CF, 11 /* ALetter */],
    [/*start*/ 0xA9D0, 9 /* Numeric */],
    [/*start*/ 0xA9DA, 0 /* Other */],
    [/*start*/ 0xA9E5, 14 /* Extend */],
    [/*start*/ 0xA9E6, 0 /* Other */],
    [/*start*/ 0xA9F0, 9 /* Numeric */],
    [/*start*/ 0xA9FA, 0 /* Other */],
    [/*start*/ 0xAA00, 11 /* ALetter */],
    [/*start*/ 0xAA29, 14 /* Extend */],
    [/*start*/ 0xAA37, 0 /* Other */],
    [/*start*/ 0xAA40, 11 /* ALetter */],
    [/*start*/ 0xAA43, 14 /* Extend */],
    [/*start*/ 0xAA44, 11 /* ALetter */],
    [/*start*/ 0xAA4C, 14 /* Extend */],
    [/*start*/ 0xAA4E, 0 /* Other */],
    [/*start*/ 0xAA50, 9 /* Numeric */],
    [/*start*/ 0xAA5A, 0 /* Other */],
    [/*start*/ 0xAA7B, 14 /* Extend */],
    [/*start*/ 0xAA7E, 0 /* Other */],
    [/*start*/ 0xAAB0, 14 /* Extend */],
    [/*start*/ 0xAAB1, 0 /* Other */],
    [/*start*/ 0xAAB2, 14 /* Extend */],
    [/*start*/ 0xAAB5, 0 /* Other */],
    [/*start*/ 0xAAB7, 14 /* Extend */],
    [/*start*/ 0xAAB9, 0 /* Other */],
    [/*start*/ 0xAABE, 14 /* Extend */],
    [/*start*/ 0xAAC0, 0 /* Other */],
    [/*start*/ 0xAAC1, 14 /* Extend */],
    [/*start*/ 0xAAC2, 0 /* Other */],
    [/*start*/ 0xAAE0, 11 /* ALetter */],
    [/*start*/ 0xAAEB, 14 /* Extend */],
    [/*start*/ 0xAAF0, 0 /* Other */],
    [/*start*/ 0xAAF2, 11 /* ALetter */],
    [/*start*/ 0xAAF5, 14 /* Extend */],
    [/*start*/ 0xAAF7, 0 /* Other */],
    [/*start*/ 0xAB01, 11 /* ALetter */],
    [/*start*/ 0xAB07, 0 /* Other */],
    [/*start*/ 0xAB09, 11 /* ALetter */],
    [/*start*/ 0xAB0F, 0 /* Other */],
    [/*start*/ 0xAB11, 11 /* ALetter */],
    [/*start*/ 0xAB17, 0 /* Other */],
    [/*start*/ 0xAB20, 11 /* ALetter */],
    [/*start*/ 0xAB27, 0 /* Other */],
    [/*start*/ 0xAB28, 11 /* ALetter */],
    [/*start*/ 0xAB2F, 0 /* Other */],
    [/*start*/ 0xAB30, 11 /* ALetter */],
    [/*start*/ 0xAB6A, 0 /* Other */],
    [/*start*/ 0xAB70, 11 /* ALetter */],
    [/*start*/ 0xABE3, 14 /* Extend */],
    [/*start*/ 0xABEB, 0 /* Other */],
    [/*start*/ 0xABEC, 14 /* Extend */],
    [/*start*/ 0xABEE, 0 /* Other */],
    [/*start*/ 0xABF0, 9 /* Numeric */],
    [/*start*/ 0xABFA, 0 /* Other */],
    [/*start*/ 0xAC00, 11 /* ALetter */],
    [/*start*/ 0xD7A4, 0 /* Other */],
    [/*start*/ 0xD7B0, 11 /* ALetter */],
    [/*start*/ 0xD7C7, 0 /* Other */],
    [/*start*/ 0xD7CB, 11 /* ALetter */],
    [/*start*/ 0xD7FC, 0 /* Other */],
    [/*start*/ 0xFB00, 11 /* ALetter */],
    [/*start*/ 0xFB07, 0 /* Other */],
    [/*start*/ 0xFB13, 11 /* ALetter */],
    [/*start*/ 0xFB18, 0 /* Other */],
    [/*start*/ 0xFB1D, 15 /* Hebrew_Letter */],
    [/*start*/ 0xFB1E, 14 /* Extend */],
    [/*start*/ 0xFB1F, 15 /* Hebrew_Letter */],
    [/*start*/ 0xFB29, 0 /* Other */],
    [/*start*/ 0xFB2A, 15 /* Hebrew_Letter */],
    [/*start*/ 0xFB37, 0 /* Other */],
    [/*start*/ 0xFB38, 15 /* Hebrew_Letter */],
    [/*start*/ 0xFB3D, 0 /* Other */],
    [/*start*/ 0xFB3E, 15 /* Hebrew_Letter */],
    [/*start*/ 0xFB3F, 0 /* Other */],
    [/*start*/ 0xFB40, 15 /* Hebrew_Letter */],
    [/*start*/ 0xFB42, 0 /* Other */],
    [/*start*/ 0xFB43, 15 /* Hebrew_Letter */],
    [/*start*/ 0xFB45, 0 /* Other */],
    [/*start*/ 0xFB46, 15 /* Hebrew_Letter */],
    [/*start*/ 0xFB50, 11 /* ALetter */],
    [/*start*/ 0xFBB2, 0 /* Other */],
    [/*start*/ 0xFBD3, 11 /* ALetter */],
    [/*start*/ 0xFD3E, 0 /* Other */],
    [/*start*/ 0xFD50, 11 /* ALetter */],
    [/*start*/ 0xFD90, 0 /* Other */],
    [/*start*/ 0xFD92, 11 /* ALetter */],
    [/*start*/ 0xFDC8, 0 /* Other */],
    [/*start*/ 0xFDF0, 11 /* ALetter */],
    [/*start*/ 0xFDFC, 0 /* Other */],
    [/*start*/ 0xFE00, 14 /* Extend */],
    [/*start*/ 0xFE10, 7 /* MidNum */],
    [/*start*/ 0xFE11, 0 /* Other */],
    [/*start*/ 0xFE13, 10 /* MidLetter */],
    [/*start*/ 0xFE14, 7 /* MidNum */],
    [/*start*/ 0xFE15, 0 /* Other */],
    [/*start*/ 0xFE20, 14 /* Extend */],
    [/*start*/ 0xFE30, 0 /* Other */],
    [/*start*/ 0xFE33, 12 /* ExtendNumLet */],
    [/*start*/ 0xFE35, 0 /* Other */],
    [/*start*/ 0xFE4D, 12 /* ExtendNumLet */],
    [/*start*/ 0xFE50, 7 /* MidNum */],
    [/*start*/ 0xFE51, 0 /* Other */],
    [/*start*/ 0xFE52, 8 /* MidNumLet */],
    [/*start*/ 0xFE53, 0 /* Other */],
    [/*start*/ 0xFE54, 7 /* MidNum */],
    [/*start*/ 0xFE55, 10 /* MidLetter */],
    [/*start*/ 0xFE56, 0 /* Other */],
    [/*start*/ 0xFE70, 11 /* ALetter */],
    [/*start*/ 0xFE75, 0 /* Other */],
    [/*start*/ 0xFE76, 11 /* ALetter */],
    [/*start*/ 0xFEFD, 0 /* Other */],
    [/*start*/ 0xFEFF, 13 /* Format */],
    [/*start*/ 0xFF00, 0 /* Other */],
    [/*start*/ 0xFF07, 8 /* MidNumLet */],
    [/*start*/ 0xFF08, 0 /* Other */],
    [/*start*/ 0xFF0C, 7 /* MidNum */],
    [/*start*/ 0xFF0D, 0 /* Other */],
    [/*start*/ 0xFF0E, 8 /* MidNumLet */],
    [/*start*/ 0xFF0F, 0 /* Other */],
    [/*start*/ 0xFF10, 9 /* Numeric */],
    [/*start*/ 0xFF1A, 10 /* MidLetter */],
    [/*start*/ 0xFF1B, 7 /* MidNum */],
    [/*start*/ 0xFF1C, 0 /* Other */],
    [/*start*/ 0xFF21, 11 /* ALetter */],
    [/*start*/ 0xFF3B, 0 /* Other */],
    [/*start*/ 0xFF3F, 12 /* ExtendNumLet */],
    [/*start*/ 0xFF40, 0 /* Other */],
    [/*start*/ 0xFF41, 11 /* ALetter */],
    [/*start*/ 0xFF5B, 0 /* Other */],
    [/*start*/ 0xFF66, 17 /* Katakana */],
    [/*start*/ 0xFF9E, 14 /* Extend */],
    [/*start*/ 0xFFA0, 11 /* ALetter */],
    [/*start*/ 0xFFBF, 0 /* Other */],
    [/*start*/ 0xFFC2, 11 /* ALetter */],
    [/*start*/ 0xFFC8, 0 /* Other */],
    [/*start*/ 0xFFCA, 11 /* ALetter */],
    [/*start*/ 0xFFD0, 0 /* Other */],
    [/*start*/ 0xFFD2, 11 /* ALetter */],
    [/*start*/ 0xFFD8, 0 /* Other */],
    [/*start*/ 0xFFDA, 11 /* ALetter */],
    [/*start*/ 0xFFDD, 0 /* Other */],
    [/*start*/ 0xFFF9, 13 /* Format */],
    [/*start*/ 0xFFFC, 0 /* Other */],
    [/*start*/ 0x10000, 11 /* ALetter */],
    [/*start*/ 0x1000C, 0 /* Other */],
    [/*start*/ 0x1000D, 11 /* ALetter */],
    [/*start*/ 0x10027, 0 /* Other */],
    [/*start*/ 0x10028, 11 /* ALetter */],
    [/*start*/ 0x1003B, 0 /* Other */],
    [/*start*/ 0x1003C, 11 /* ALetter */],
    [/*start*/ 0x1003E, 0 /* Other */],
    [/*start*/ 0x1003F, 11 /* ALetter */],
    [/*start*/ 0x1004E, 0 /* Other */],
    [/*start*/ 0x10050, 11 /* ALetter */],
    [/*start*/ 0x1005E, 0 /* Other */],
    [/*start*/ 0x10080, 11 /* ALetter */],
    [/*start*/ 0x100FB, 0 /* Other */],
    [/*start*/ 0x10140, 11 /* ALetter */],
    [/*start*/ 0x10175, 0 /* Other */],
    [/*start*/ 0x101FD, 14 /* Extend */],
    [/*start*/ 0x101FE, 0 /* Other */],
    [/*start*/ 0x10280, 11 /* ALetter */],
    [/*start*/ 0x1029D, 0 /* Other */],
    [/*start*/ 0x102A0, 11 /* ALetter */],
    [/*start*/ 0x102D1, 0 /* Other */],
    [/*start*/ 0x102E0, 14 /* Extend */],
    [/*start*/ 0x102E1, 0 /* Other */],
    [/*start*/ 0x10300, 11 /* ALetter */],
    [/*start*/ 0x10320, 0 /* Other */],
    [/*start*/ 0x1032D, 11 /* ALetter */],
    [/*start*/ 0x1034B, 0 /* Other */],
    [/*start*/ 0x10350, 11 /* ALetter */],
    [/*start*/ 0x10376, 14 /* Extend */],
    [/*start*/ 0x1037B, 0 /* Other */],
    [/*start*/ 0x10380, 11 /* ALetter */],
    [/*start*/ 0x1039E, 0 /* Other */],
    [/*start*/ 0x103A0, 11 /* ALetter */],
    [/*start*/ 0x103C4, 0 /* Other */],
    [/*start*/ 0x103C8, 11 /* ALetter */],
    [/*start*/ 0x103D0, 0 /* Other */],
    [/*start*/ 0x103D1, 11 /* ALetter */],
    [/*start*/ 0x103D6, 0 /* Other */],
    [/*start*/ 0x10400, 11 /* ALetter */],
    [/*start*/ 0x1049E, 0 /* Other */],
    [/*start*/ 0x104A0, 9 /* Numeric */],
    [/*start*/ 0x104AA, 0 /* Other */],
    [/*start*/ 0x104B0, 11 /* ALetter */],
    [/*start*/ 0x104D4, 0 /* Other */],
    [/*start*/ 0x104D8, 11 /* ALetter */],
    [/*start*/ 0x104FC, 0 /* Other */],
    [/*start*/ 0x10500, 11 /* ALetter */],
    [/*start*/ 0x10528, 0 /* Other */],
    [/*start*/ 0x10530, 11 /* ALetter */],
    [/*start*/ 0x10564, 0 /* Other */],
    [/*start*/ 0x10600, 11 /* ALetter */],
    [/*start*/ 0x10737, 0 /* Other */],
    [/*start*/ 0x10740, 11 /* ALetter */],
    [/*start*/ 0x10756, 0 /* Other */],
    [/*start*/ 0x10760, 11 /* ALetter */],
    [/*start*/ 0x10768, 0 /* Other */],
    [/*start*/ 0x10800, 11 /* ALetter */],
    [/*start*/ 0x10806, 0 /* Other */],
    [/*start*/ 0x10808, 11 /* ALetter */],
    [/*start*/ 0x10809, 0 /* Other */],
    [/*start*/ 0x1080A, 11 /* ALetter */],
    [/*start*/ 0x10836, 0 /* Other */],
    [/*start*/ 0x10837, 11 /* ALetter */],
    [/*start*/ 0x10839, 0 /* Other */],
    [/*start*/ 0x1083C, 11 /* ALetter */],
    [/*start*/ 0x1083D, 0 /* Other */],
    [/*start*/ 0x1083F, 11 /* ALetter */],
    [/*start*/ 0x10856, 0 /* Other */],
    [/*start*/ 0x10860, 11 /* ALetter */],
    [/*start*/ 0x10877, 0 /* Other */],
    [/*start*/ 0x10880, 11 /* ALetter */],
    [/*start*/ 0x1089F, 0 /* Other */],
    [/*start*/ 0x108E0, 11 /* ALetter */],
    [/*start*/ 0x108F3, 0 /* Other */],
    [/*start*/ 0x108F4, 11 /* ALetter */],
    [/*start*/ 0x108F6, 0 /* Other */],
    [/*start*/ 0x10900, 11 /* ALetter */],
    [/*start*/ 0x10916, 0 /* Other */],
    [/*start*/ 0x10920, 11 /* ALetter */],
    [/*start*/ 0x1093A, 0 /* Other */],
    [/*start*/ 0x10980, 11 /* ALetter */],
    [/*start*/ 0x109B8, 0 /* Other */],
    [/*start*/ 0x109BE, 11 /* ALetter */],
    [/*start*/ 0x109C0, 0 /* Other */],
    [/*start*/ 0x10A00, 11 /* ALetter */],
    [/*start*/ 0x10A01, 14 /* Extend */],
    [/*start*/ 0x10A04, 0 /* Other */],
    [/*start*/ 0x10A05, 14 /* Extend */],
    [/*start*/ 0x10A07, 0 /* Other */],
    [/*start*/ 0x10A0C, 14 /* Extend */],
    [/*start*/ 0x10A10, 11 /* ALetter */],
    [/*start*/ 0x10A14, 0 /* Other */],
    [/*start*/ 0x10A15, 11 /* ALetter */],
    [/*start*/ 0x10A18, 0 /* Other */],
    [/*start*/ 0x10A19, 11 /* ALetter */],
    [/*start*/ 0x10A36, 0 /* Other */],
    [/*start*/ 0x10A38, 14 /* Extend */],
    [/*start*/ 0x10A3B, 0 /* Other */],
    [/*start*/ 0x10A3F, 14 /* Extend */],
    [/*start*/ 0x10A40, 0 /* Other */],
    [/*start*/ 0x10A60, 11 /* ALetter */],
    [/*start*/ 0x10A7D, 0 /* Other */],
    [/*start*/ 0x10A80, 11 /* ALetter */],
    [/*start*/ 0x10A9D, 0 /* Other */],
    [/*start*/ 0x10AC0, 11 /* ALetter */],
    [/*start*/ 0x10AC8, 0 /* Other */],
    [/*start*/ 0x10AC9, 11 /* ALetter */],
    [/*start*/ 0x10AE5, 14 /* Extend */],
    [/*start*/ 0x10AE7, 0 /* Other */],
    [/*start*/ 0x10B00, 11 /* ALetter */],
    [/*start*/ 0x10B36, 0 /* Other */],
    [/*start*/ 0x10B40, 11 /* ALetter */],
    [/*start*/ 0x10B56, 0 /* Other */],
    [/*start*/ 0x10B60, 11 /* ALetter */],
    [/*start*/ 0x10B73, 0 /* Other */],
    [/*start*/ 0x10B80, 11 /* ALetter */],
    [/*start*/ 0x10B92, 0 /* Other */],
    [/*start*/ 0x10C00, 11 /* ALetter */],
    [/*start*/ 0x10C49, 0 /* Other */],
    [/*start*/ 0x10C80, 11 /* ALetter */],
    [/*start*/ 0x10CB3, 0 /* Other */],
    [/*start*/ 0x10CC0, 11 /* ALetter */],
    [/*start*/ 0x10CF3, 0 /* Other */],
    [/*start*/ 0x10D00, 11 /* ALetter */],
    [/*start*/ 0x10D24, 14 /* Extend */],
    [/*start*/ 0x10D28, 0 /* Other */],
    [/*start*/ 0x10D30, 9 /* Numeric */],
    [/*start*/ 0x10D3A, 0 /* Other */],
    [/*start*/ 0x10E80, 11 /* ALetter */],
    [/*start*/ 0x10EAA, 0 /* Other */],
    [/*start*/ 0x10EAB, 14 /* Extend */],
    [/*start*/ 0x10EAD, 0 /* Other */],
    [/*start*/ 0x10EB0, 11 /* ALetter */],
    [/*start*/ 0x10EB2, 0 /* Other */],
    [/*start*/ 0x10F00, 11 /* ALetter */],
    [/*start*/ 0x10F1D, 0 /* Other */],
    [/*start*/ 0x10F27, 11 /* ALetter */],
    [/*start*/ 0x10F28, 0 /* Other */],
    [/*start*/ 0x10F30, 11 /* ALetter */],
    [/*start*/ 0x10F46, 14 /* Extend */],
    [/*start*/ 0x10F51, 0 /* Other */],
    [/*start*/ 0x10FB0, 11 /* ALetter */],
    [/*start*/ 0x10FC5, 0 /* Other */],
    [/*start*/ 0x10FE0, 11 /* ALetter */],
    [/*start*/ 0x10FF7, 0 /* Other */],
    [/*start*/ 0x11000, 14 /* Extend */],
    [/*start*/ 0x11003, 11 /* ALetter */],
    [/*start*/ 0x11038, 14 /* Extend */],
    [/*start*/ 0x11047, 0 /* Other */],
    [/*start*/ 0x11066, 9 /* Numeric */],
    [/*start*/ 0x11070, 0 /* Other */],
    [/*start*/ 0x1107F, 14 /* Extend */],
    [/*start*/ 0x11083, 11 /* ALetter */],
    [/*start*/ 0x110B0, 14 /* Extend */],
    [/*start*/ 0x110BB, 0 /* Other */],
    [/*start*/ 0x110BD, 13 /* Format */],
    [/*start*/ 0x110BE, 0 /* Other */],
    [/*start*/ 0x110CD, 13 /* Format */],
    [/*start*/ 0x110CE, 0 /* Other */],
    [/*start*/ 0x110D0, 11 /* ALetter */],
    [/*start*/ 0x110E9, 0 /* Other */],
    [/*start*/ 0x110F0, 9 /* Numeric */],
    [/*start*/ 0x110FA, 0 /* Other */],
    [/*start*/ 0x11100, 14 /* Extend */],
    [/*start*/ 0x11103, 11 /* ALetter */],
    [/*start*/ 0x11127, 14 /* Extend */],
    [/*start*/ 0x11135, 0 /* Other */],
    [/*start*/ 0x11136, 9 /* Numeric */],
    [/*start*/ 0x11140, 0 /* Other */],
    [/*start*/ 0x11144, 11 /* ALetter */],
    [/*start*/ 0x11145, 14 /* Extend */],
    [/*start*/ 0x11147, 11 /* ALetter */],
    [/*start*/ 0x11148, 0 /* Other */],
    [/*start*/ 0x11150, 11 /* ALetter */],
    [/*start*/ 0x11173, 14 /* Extend */],
    [/*start*/ 0x11174, 0 /* Other */],
    [/*start*/ 0x11176, 11 /* ALetter */],
    [/*start*/ 0x11177, 0 /* Other */],
    [/*start*/ 0x11180, 14 /* Extend */],
    [/*start*/ 0x11183, 11 /* ALetter */],
    [/*start*/ 0x111B3, 14 /* Extend */],
    [/*start*/ 0x111C1, 11 /* ALetter */],
    [/*start*/ 0x111C5, 0 /* Other */],
    [/*start*/ 0x111C9, 14 /* Extend */],
    [/*start*/ 0x111CD, 0 /* Other */],
    [/*start*/ 0x111CE, 14 /* Extend */],
    [/*start*/ 0x111D0, 9 /* Numeric */],
    [/*start*/ 0x111DA, 11 /* ALetter */],
    [/*start*/ 0x111DB, 0 /* Other */],
    [/*start*/ 0x111DC, 11 /* ALetter */],
    [/*start*/ 0x111DD, 0 /* Other */],
    [/*start*/ 0x11200, 11 /* ALetter */],
    [/*start*/ 0x11212, 0 /* Other */],
    [/*start*/ 0x11213, 11 /* ALetter */],
    [/*start*/ 0x1122C, 14 /* Extend */],
    [/*start*/ 0x11238, 0 /* Other */],
    [/*start*/ 0x1123E, 14 /* Extend */],
    [/*start*/ 0x1123F, 0 /* Other */],
    [/*start*/ 0x11280, 11 /* ALetter */],
    [/*start*/ 0x11287, 0 /* Other */],
    [/*start*/ 0x11288, 11 /* ALetter */],
    [/*start*/ 0x11289, 0 /* Other */],
    [/*start*/ 0x1128A, 11 /* ALetter */],
    [/*start*/ 0x1128E, 0 /* Other */],
    [/*start*/ 0x1128F, 11 /* ALetter */],
    [/*start*/ 0x1129E, 0 /* Other */],
    [/*start*/ 0x1129F, 11 /* ALetter */],
    [/*start*/ 0x112A9, 0 /* Other */],
    [/*start*/ 0x112B0, 11 /* ALetter */],
    [/*start*/ 0x112DF, 14 /* Extend */],
    [/*start*/ 0x112EB, 0 /* Other */],
    [/*start*/ 0x112F0, 9 /* Numeric */],
    [/*start*/ 0x112FA, 0 /* Other */],
    [/*start*/ 0x11300, 14 /* Extend */],
    [/*start*/ 0x11304, 0 /* Other */],
    [/*start*/ 0x11305, 11 /* ALetter */],
    [/*start*/ 0x1130D, 0 /* Other */],
    [/*start*/ 0x1130F, 11 /* ALetter */],
    [/*start*/ 0x11311, 0 /* Other */],
    [/*start*/ 0x11313, 11 /* ALetter */],
    [/*start*/ 0x11329, 0 /* Other */],
    [/*start*/ 0x1132A, 11 /* ALetter */],
    [/*start*/ 0x11331, 0 /* Other */],
    [/*start*/ 0x11332, 11 /* ALetter */],
    [/*start*/ 0x11334, 0 /* Other */],
    [/*start*/ 0x11335, 11 /* ALetter */],
    [/*start*/ 0x1133A, 0 /* Other */],
    [/*start*/ 0x1133B, 14 /* Extend */],
    [/*start*/ 0x1133D, 11 /* ALetter */],
    [/*start*/ 0x1133E, 14 /* Extend */],
    [/*start*/ 0x11345, 0 /* Other */],
    [/*start*/ 0x11347, 14 /* Extend */],
    [/*start*/ 0x11349, 0 /* Other */],
    [/*start*/ 0x1134B, 14 /* Extend */],
    [/*start*/ 0x1134E, 0 /* Other */],
    [/*start*/ 0x11350, 11 /* ALetter */],
    [/*start*/ 0x11351, 0 /* Other */],
    [/*start*/ 0x11357, 14 /* Extend */],
    [/*start*/ 0x11358, 0 /* Other */],
    [/*start*/ 0x1135D, 11 /* ALetter */],
    [/*start*/ 0x11362, 14 /* Extend */],
    [/*start*/ 0x11364, 0 /* Other */],
    [/*start*/ 0x11366, 14 /* Extend */],
    [/*start*/ 0x1136D, 0 /* Other */],
    [/*start*/ 0x11370, 14 /* Extend */],
    [/*start*/ 0x11375, 0 /* Other */],
    [/*start*/ 0x11400, 11 /* ALetter */],
    [/*start*/ 0x11435, 14 /* Extend */],
    [/*start*/ 0x11447, 11 /* ALetter */],
    [/*start*/ 0x1144B, 0 /* Other */],
    [/*start*/ 0x11450, 9 /* Numeric */],
    [/*start*/ 0x1145A, 0 /* Other */],
    [/*start*/ 0x1145E, 14 /* Extend */],
    [/*start*/ 0x1145F, 11 /* ALetter */],
    [/*start*/ 0x11462, 0 /* Other */],
    [/*start*/ 0x11480, 11 /* ALetter */],
    [/*start*/ 0x114B0, 14 /* Extend */],
    [/*start*/ 0x114C4, 11 /* ALetter */],
    [/*start*/ 0x114C6, 0 /* Other */],
    [/*start*/ 0x114C7, 11 /* ALetter */],
    [/*start*/ 0x114C8, 0 /* Other */],
    [/*start*/ 0x114D0, 9 /* Numeric */],
    [/*start*/ 0x114DA, 0 /* Other */],
    [/*start*/ 0x11580, 11 /* ALetter */],
    [/*start*/ 0x115AF, 14 /* Extend */],
    [/*start*/ 0x115B6, 0 /* Other */],
    [/*start*/ 0x115B8, 14 /* Extend */],
    [/*start*/ 0x115C1, 0 /* Other */],
    [/*start*/ 0x115D8, 11 /* ALetter */],
    [/*start*/ 0x115DC, 14 /* Extend */],
    [/*start*/ 0x115DE, 0 /* Other */],
    [/*start*/ 0x11600, 11 /* ALetter */],
    [/*start*/ 0x11630, 14 /* Extend */],
    [/*start*/ 0x11641, 0 /* Other */],
    [/*start*/ 0x11644, 11 /* ALetter */],
    [/*start*/ 0x11645, 0 /* Other */],
    [/*start*/ 0x11650, 9 /* Numeric */],
    [/*start*/ 0x1165A, 0 /* Other */],
    [/*start*/ 0x11680, 11 /* ALetter */],
    [/*start*/ 0x116AB, 14 /* Extend */],
    [/*start*/ 0x116B8, 11 /* ALetter */],
    [/*start*/ 0x116B9, 0 /* Other */],
    [/*start*/ 0x116C0, 9 /* Numeric */],
    [/*start*/ 0x116CA, 0 /* Other */],
    [/*start*/ 0x1171D, 14 /* Extend */],
    [/*start*/ 0x1172C, 0 /* Other */],
    [/*start*/ 0x11730, 9 /* Numeric */],
    [/*start*/ 0x1173A, 0 /* Other */],
    [/*start*/ 0x11800, 11 /* ALetter */],
    [/*start*/ 0x1182C, 14 /* Extend */],
    [/*start*/ 0x1183B, 0 /* Other */],
    [/*start*/ 0x118A0, 11 /* ALetter */],
    [/*start*/ 0x118E0, 9 /* Numeric */],
    [/*start*/ 0x118EA, 0 /* Other */],
    [/*start*/ 0x118FF, 11 /* ALetter */],
    [/*start*/ 0x11907, 0 /* Other */],
    [/*start*/ 0x11909, 11 /* ALetter */],
    [/*start*/ 0x1190A, 0 /* Other */],
    [/*start*/ 0x1190C, 11 /* ALetter */],
    [/*start*/ 0x11914, 0 /* Other */],
    [/*start*/ 0x11915, 11 /* ALetter */],
    [/*start*/ 0x11917, 0 /* Other */],
    [/*start*/ 0x11918, 11 /* ALetter */],
    [/*start*/ 0x11930, 14 /* Extend */],
    [/*start*/ 0x11936, 0 /* Other */],
    [/*start*/ 0x11937, 14 /* Extend */],
    [/*start*/ 0x11939, 0 /* Other */],
    [/*start*/ 0x1193B, 14 /* Extend */],
    [/*start*/ 0x1193F, 11 /* ALetter */],
    [/*start*/ 0x11940, 14 /* Extend */],
    [/*start*/ 0x11941, 11 /* ALetter */],
    [/*start*/ 0x11942, 14 /* Extend */],
    [/*start*/ 0x11944, 0 /* Other */],
    [/*start*/ 0x11950, 9 /* Numeric */],
    [/*start*/ 0x1195A, 0 /* Other */],
    [/*start*/ 0x119A0, 11 /* ALetter */],
    [/*start*/ 0x119A8, 0 /* Other */],
    [/*start*/ 0x119AA, 11 /* ALetter */],
    [/*start*/ 0x119D1, 14 /* Extend */],
    [/*start*/ 0x119D8, 0 /* Other */],
    [/*start*/ 0x119DA, 14 /* Extend */],
    [/*start*/ 0x119E1, 11 /* ALetter */],
    [/*start*/ 0x119E2, 0 /* Other */],
    [/*start*/ 0x119E3, 11 /* ALetter */],
    [/*start*/ 0x119E4, 14 /* Extend */],
    [/*start*/ 0x119E5, 0 /* Other */],
    [/*start*/ 0x11A00, 11 /* ALetter */],
    [/*start*/ 0x11A01, 14 /* Extend */],
    [/*start*/ 0x11A0B, 11 /* ALetter */],
    [/*start*/ 0x11A33, 14 /* Extend */],
    [/*start*/ 0x11A3A, 11 /* ALetter */],
    [/*start*/ 0x11A3B, 14 /* Extend */],
    [/*start*/ 0x11A3F, 0 /* Other */],
    [/*start*/ 0x11A47, 14 /* Extend */],
    [/*start*/ 0x11A48, 0 /* Other */],
    [/*start*/ 0x11A50, 11 /* ALetter */],
    [/*start*/ 0x11A51, 14 /* Extend */],
    [/*start*/ 0x11A5C, 11 /* ALetter */],
    [/*start*/ 0x11A8A, 14 /* Extend */],
    [/*start*/ 0x11A9A, 0 /* Other */],
    [/*start*/ 0x11A9D, 11 /* ALetter */],
    [/*start*/ 0x11A9E, 0 /* Other */],
    [/*start*/ 0x11AC0, 11 /* ALetter */],
    [/*start*/ 0x11AF9, 0 /* Other */],
    [/*start*/ 0x11C00, 11 /* ALetter */],
    [/*start*/ 0x11C09, 0 /* Other */],
    [/*start*/ 0x11C0A, 11 /* ALetter */],
    [/*start*/ 0x11C2F, 14 /* Extend */],
    [/*start*/ 0x11C37, 0 /* Other */],
    [/*start*/ 0x11C38, 14 /* Extend */],
    [/*start*/ 0x11C40, 11 /* ALetter */],
    [/*start*/ 0x11C41, 0 /* Other */],
    [/*start*/ 0x11C50, 9 /* Numeric */],
    [/*start*/ 0x11C5A, 0 /* Other */],
    [/*start*/ 0x11C72, 11 /* ALetter */],
    [/*start*/ 0x11C90, 0 /* Other */],
    [/*start*/ 0x11C92, 14 /* Extend */],
    [/*start*/ 0x11CA8, 0 /* Other */],
    [/*start*/ 0x11CA9, 14 /* Extend */],
    [/*start*/ 0x11CB7, 0 /* Other */],
    [/*start*/ 0x11D00, 11 /* ALetter */],
    [/*start*/ 0x11D07, 0 /* Other */],
    [/*start*/ 0x11D08, 11 /* ALetter */],
    [/*start*/ 0x11D0A, 0 /* Other */],
    [/*start*/ 0x11D0B, 11 /* ALetter */],
    [/*start*/ 0x11D31, 14 /* Extend */],
    [/*start*/ 0x11D37, 0 /* Other */],
    [/*start*/ 0x11D3A, 14 /* Extend */],
    [/*start*/ 0x11D3B, 0 /* Other */],
    [/*start*/ 0x11D3C, 14 /* Extend */],
    [/*start*/ 0x11D3E, 0 /* Other */],
    [/*start*/ 0x11D3F, 14 /* Extend */],
    [/*start*/ 0x11D46, 11 /* ALetter */],
    [/*start*/ 0x11D47, 14 /* Extend */],
    [/*start*/ 0x11D48, 0 /* Other */],
    [/*start*/ 0x11D50, 9 /* Numeric */],
    [/*start*/ 0x11D5A, 0 /* Other */],
    [/*start*/ 0x11D60, 11 /* ALetter */],
    [/*start*/ 0x11D66, 0 /* Other */],
    [/*start*/ 0x11D67, 11 /* ALetter */],
    [/*start*/ 0x11D69, 0 /* Other */],
    [/*start*/ 0x11D6A, 11 /* ALetter */],
    [/*start*/ 0x11D8A, 14 /* Extend */],
    [/*start*/ 0x11D8F, 0 /* Other */],
    [/*start*/ 0x11D90, 14 /* Extend */],
    [/*start*/ 0x11D92, 0 /* Other */],
    [/*start*/ 0x11D93, 14 /* Extend */],
    [/*start*/ 0x11D98, 11 /* ALetter */],
    [/*start*/ 0x11D99, 0 /* Other */],
    [/*start*/ 0x11DA0, 9 /* Numeric */],
    [/*start*/ 0x11DAA, 0 /* Other */],
    [/*start*/ 0x11EE0, 11 /* ALetter */],
    [/*start*/ 0x11EF3, 14 /* Extend */],
    [/*start*/ 0x11EF7, 0 /* Other */],
    [/*start*/ 0x11FB0, 11 /* ALetter */],
    [/*start*/ 0x11FB1, 0 /* Other */],
    [/*start*/ 0x12000, 11 /* ALetter */],
    [/*start*/ 0x1239A, 0 /* Other */],
    [/*start*/ 0x12400, 11 /* ALetter */],
    [/*start*/ 0x1246F, 0 /* Other */],
    [/*start*/ 0x12480, 11 /* ALetter */],
    [/*start*/ 0x12544, 0 /* Other */],
    [/*start*/ 0x13000, 11 /* ALetter */],
    [/*start*/ 0x1342F, 0 /* Other */],
    [/*start*/ 0x13430, 13 /* Format */],
    [/*start*/ 0x13439, 0 /* Other */],
    [/*start*/ 0x14400, 11 /* ALetter */],
    [/*start*/ 0x14647, 0 /* Other */],
    [/*start*/ 0x16800, 11 /* ALetter */],
    [/*start*/ 0x16A39, 0 /* Other */],
    [/*start*/ 0x16A40, 11 /* ALetter */],
    [/*start*/ 0x16A5F, 0 /* Other */],
    [/*start*/ 0x16A60, 9 /* Numeric */],
    [/*start*/ 0x16A6A, 0 /* Other */],
    [/*start*/ 0x16AD0, 11 /* ALetter */],
    [/*start*/ 0x16AEE, 0 /* Other */],
    [/*start*/ 0x16AF0, 14 /* Extend */],
    [/*start*/ 0x16AF5, 0 /* Other */],
    [/*start*/ 0x16B00, 11 /* ALetter */],
    [/*start*/ 0x16B30, 14 /* Extend */],
    [/*start*/ 0x16B37, 0 /* Other */],
    [/*start*/ 0x16B40, 11 /* ALetter */],
    [/*start*/ 0x16B44, 0 /* Other */],
    [/*start*/ 0x16B50, 9 /* Numeric */],
    [/*start*/ 0x16B5A, 0 /* Other */],
    [/*start*/ 0x16B63, 11 /* ALetter */],
    [/*start*/ 0x16B78, 0 /* Other */],
    [/*start*/ 0x16B7D, 11 /* ALetter */],
    [/*start*/ 0x16B90, 0 /* Other */],
    [/*start*/ 0x16E40, 11 /* ALetter */],
    [/*start*/ 0x16E80, 0 /* Other */],
    [/*start*/ 0x16F00, 11 /* ALetter */],
    [/*start*/ 0x16F4B, 0 /* Other */],
    [/*start*/ 0x16F4F, 14 /* Extend */],
    [/*start*/ 0x16F50, 11 /* ALetter */],
    [/*start*/ 0x16F51, 14 /* Extend */],
    [/*start*/ 0x16F88, 0 /* Other */],
    [/*start*/ 0x16F8F, 14 /* Extend */],
    [/*start*/ 0x16F93, 11 /* ALetter */],
    [/*start*/ 0x16FA0, 0 /* Other */],
    [/*start*/ 0x16FE0, 11 /* ALetter */],
    [/*start*/ 0x16FE2, 0 /* Other */],
    [/*start*/ 0x16FE3, 11 /* ALetter */],
    [/*start*/ 0x16FE4, 14 /* Extend */],
    [/*start*/ 0x16FE5, 0 /* Other */],
    [/*start*/ 0x16FF0, 14 /* Extend */],
    [/*start*/ 0x16FF2, 0 /* Other */],
    [/*start*/ 0x1B000, 17 /* Katakana */],
    [/*start*/ 0x1B001, 0 /* Other */],
    [/*start*/ 0x1B164, 17 /* Katakana */],
    [/*start*/ 0x1B168, 0 /* Other */],
    [/*start*/ 0x1BC00, 11 /* ALetter */],
    [/*start*/ 0x1BC6B, 0 /* Other */],
    [/*start*/ 0x1BC70, 11 /* ALetter */],
    [/*start*/ 0x1BC7D, 0 /* Other */],
    [/*start*/ 0x1BC80, 11 /* ALetter */],
    [/*start*/ 0x1BC89, 0 /* Other */],
    [/*start*/ 0x1BC90, 11 /* ALetter */],
    [/*start*/ 0x1BC9A, 0 /* Other */],
    [/*start*/ 0x1BC9D, 14 /* Extend */],
    [/*start*/ 0x1BC9F, 0 /* Other */],
    [/*start*/ 0x1BCA0, 13 /* Format */],
    [/*start*/ 0x1BCA4, 0 /* Other */],
    [/*start*/ 0x1D165, 14 /* Extend */],
    [/*start*/ 0x1D16A, 0 /* Other */],
    [/*start*/ 0x1D16D, 14 /* Extend */],
    [/*start*/ 0x1D173, 13 /* Format */],
    [/*start*/ 0x1D17B, 14 /* Extend */],
    [/*start*/ 0x1D183, 0 /* Other */],
    [/*start*/ 0x1D185, 14 /* Extend */],
    [/*start*/ 0x1D18C, 0 /* Other */],
    [/*start*/ 0x1D1AA, 14 /* Extend */],
    [/*start*/ 0x1D1AE, 0 /* Other */],
    [/*start*/ 0x1D242, 14 /* Extend */],
    [/*start*/ 0x1D245, 0 /* Other */],
    [/*start*/ 0x1D400, 11 /* ALetter */],
    [/*start*/ 0x1D455, 0 /* Other */],
    [/*start*/ 0x1D456, 11 /* ALetter */],
    [/*start*/ 0x1D49D, 0 /* Other */],
    [/*start*/ 0x1D49E, 11 /* ALetter */],
    [/*start*/ 0x1D4A0, 0 /* Other */],
    [/*start*/ 0x1D4A2, 11 /* ALetter */],
    [/*start*/ 0x1D4A3, 0 /* Other */],
    [/*start*/ 0x1D4A5, 11 /* ALetter */],
    [/*start*/ 0x1D4A7, 0 /* Other */],
    [/*start*/ 0x1D4A9, 11 /* ALetter */],
    [/*start*/ 0x1D4AD, 0 /* Other */],
    [/*start*/ 0x1D4AE, 11 /* ALetter */],
    [/*start*/ 0x1D4BA, 0 /* Other */],
    [/*start*/ 0x1D4BB, 11 /* ALetter */],
    [/*start*/ 0x1D4BC, 0 /* Other */],
    [/*start*/ 0x1D4BD, 11 /* ALetter */],
    [/*start*/ 0x1D4C4, 0 /* Other */],
    [/*start*/ 0x1D4C5, 11 /* ALetter */],
    [/*start*/ 0x1D506, 0 /* Other */],
    [/*start*/ 0x1D507, 11 /* ALetter */],
    [/*start*/ 0x1D50B, 0 /* Other */],
    [/*start*/ 0x1D50D, 11 /* ALetter */],
    [/*start*/ 0x1D515, 0 /* Other */],
    [/*start*/ 0x1D516, 11 /* ALetter */],
    [/*start*/ 0x1D51D, 0 /* Other */],
    [/*start*/ 0x1D51E, 11 /* ALetter */],
    [/*start*/ 0x1D53A, 0 /* Other */],
    [/*start*/ 0x1D53B, 11 /* ALetter */],
    [/*start*/ 0x1D53F, 0 /* Other */],
    [/*start*/ 0x1D540, 11 /* ALetter */],
    [/*start*/ 0x1D545, 0 /* Other */],
    [/*start*/ 0x1D546, 11 /* ALetter */],
    [/*start*/ 0x1D547, 0 /* Other */],
    [/*start*/ 0x1D54A, 11 /* ALetter */],
    [/*start*/ 0x1D551, 0 /* Other */],
    [/*start*/ 0x1D552, 11 /* ALetter */],
    [/*start*/ 0x1D6A6, 0 /* Other */],
    [/*start*/ 0x1D6A8, 11 /* ALetter */],
    [/*start*/ 0x1D6C1, 0 /* Other */],
    [/*start*/ 0x1D6C2, 11 /* ALetter */],
    [/*start*/ 0x1D6DB, 0 /* Other */],
    [/*start*/ 0x1D6DC, 11 /* ALetter */],
    [/*start*/ 0x1D6FB, 0 /* Other */],
    [/*start*/ 0x1D6FC, 11 /* ALetter */],
    [/*start*/ 0x1D715, 0 /* Other */],
    [/*start*/ 0x1D716, 11 /* ALetter */],
    [/*start*/ 0x1D735, 0 /* Other */],
    [/*start*/ 0x1D736, 11 /* ALetter */],
    [/*start*/ 0x1D74F, 0 /* Other */],
    [/*start*/ 0x1D750, 11 /* ALetter */],
    [/*start*/ 0x1D76F, 0 /* Other */],
    [/*start*/ 0x1D770, 11 /* ALetter */],
    [/*start*/ 0x1D789, 0 /* Other */],
    [/*start*/ 0x1D78A, 11 /* ALetter */],
    [/*start*/ 0x1D7A9, 0 /* Other */],
    [/*start*/ 0x1D7AA, 11 /* ALetter */],
    [/*start*/ 0x1D7C3, 0 /* Other */],
    [/*start*/ 0x1D7C4, 11 /* ALetter */],
    [/*start*/ 0x1D7CC, 0 /* Other */],
    [/*start*/ 0x1D7CE, 9 /* Numeric */],
    [/*start*/ 0x1D800, 0 /* Other */],
    [/*start*/ 0x1DA00, 14 /* Extend */],
    [/*start*/ 0x1DA37, 0 /* Other */],
    [/*start*/ 0x1DA3B, 14 /* Extend */],
    [/*start*/ 0x1DA6D, 0 /* Other */],
    [/*start*/ 0x1DA75, 14 /* Extend */],
    [/*start*/ 0x1DA76, 0 /* Other */],
    [/*start*/ 0x1DA84, 14 /* Extend */],
    [/*start*/ 0x1DA85, 0 /* Other */],
    [/*start*/ 0x1DA9B, 14 /* Extend */],
    [/*start*/ 0x1DAA0, 0 /* Other */],
    [/*start*/ 0x1DAA1, 14 /* Extend */],
    [/*start*/ 0x1DAB0, 0 /* Other */],
    [/*start*/ 0x1E000, 14 /* Extend */],
    [/*start*/ 0x1E007, 0 /* Other */],
    [/*start*/ 0x1E008, 14 /* Extend */],
    [/*start*/ 0x1E019, 0 /* Other */],
    [/*start*/ 0x1E01B, 14 /* Extend */],
    [/*start*/ 0x1E022, 0 /* Other */],
    [/*start*/ 0x1E023, 14 /* Extend */],
    [/*start*/ 0x1E025, 0 /* Other */],
    [/*start*/ 0x1E026, 14 /* Extend */],
    [/*start*/ 0x1E02B, 0 /* Other */],
    [/*start*/ 0x1E100, 11 /* ALetter */],
    [/*start*/ 0x1E12D, 0 /* Other */],
    [/*start*/ 0x1E130, 14 /* Extend */],
    [/*start*/ 0x1E137, 11 /* ALetter */],
    [/*start*/ 0x1E13E, 0 /* Other */],
    [/*start*/ 0x1E140, 9 /* Numeric */],
    [/*start*/ 0x1E14A, 0 /* Other */],
    [/*start*/ 0x1E14E, 11 /* ALetter */],
    [/*start*/ 0x1E14F, 0 /* Other */],
    [/*start*/ 0x1E2C0, 11 /* ALetter */],
    [/*start*/ 0x1E2EC, 14 /* Extend */],
    [/*start*/ 0x1E2F0, 9 /* Numeric */],
    [/*start*/ 0x1E2FA, 0 /* Other */],
    [/*start*/ 0x1E800, 11 /* ALetter */],
    [/*start*/ 0x1E8C5, 0 /* Other */],
    [/*start*/ 0x1E8D0, 14 /* Extend */],
    [/*start*/ 0x1E8D7, 0 /* Other */],
    [/*start*/ 0x1E900, 11 /* ALetter */],
    [/*start*/ 0x1E944, 14 /* Extend */],
    [/*start*/ 0x1E94B, 11 /* ALetter */],
    [/*start*/ 0x1E94C, 0 /* Other */],
    [/*start*/ 0x1E950, 9 /* Numeric */],
    [/*start*/ 0x1E95A, 0 /* Other */],
    [/*start*/ 0x1EE00, 11 /* ALetter */],
    [/*start*/ 0x1EE04, 0 /* Other */],
    [/*start*/ 0x1EE05, 11 /* ALetter */],
    [/*start*/ 0x1EE20, 0 /* Other */],
    [/*start*/ 0x1EE21, 11 /* ALetter */],
    [/*start*/ 0x1EE23, 0 /* Other */],
    [/*start*/ 0x1EE24, 11 /* ALetter */],
    [/*start*/ 0x1EE25, 0 /* Other */],
    [/*start*/ 0x1EE27, 11 /* ALetter */],
    [/*start*/ 0x1EE28, 0 /* Other */],
    [/*start*/ 0x1EE29, 11 /* ALetter */],
    [/*start*/ 0x1EE33, 0 /* Other */],
    [/*start*/ 0x1EE34, 11 /* ALetter */],
    [/*start*/ 0x1EE38, 0 /* Other */],
    [/*start*/ 0x1EE39, 11 /* ALetter */],
    [/*start*/ 0x1EE3A, 0 /* Other */],
    [/*start*/ 0x1EE3B, 11 /* ALetter */],
    [/*start*/ 0x1EE3C, 0 /* Other */],
    [/*start*/ 0x1EE42, 11 /* ALetter */],
    [/*start*/ 0x1EE43, 0 /* Other */],
    [/*start*/ 0x1EE47, 11 /* ALetter */],
    [/*start*/ 0x1EE48, 0 /* Other */],
    [/*start*/ 0x1EE49, 11 /* ALetter */],
    [/*start*/ 0x1EE4A, 0 /* Other */],
    [/*start*/ 0x1EE4B, 11 /* ALetter */],
    [/*start*/ 0x1EE4C, 0 /* Other */],
    [/*start*/ 0x1EE4D, 11 /* ALetter */],
    [/*start*/ 0x1EE50, 0 /* Other */],
    [/*start*/ 0x1EE51, 11 /* ALetter */],
    [/*start*/ 0x1EE53, 0 /* Other */],
    [/*start*/ 0x1EE54, 11 /* ALetter */],
    [/*start*/ 0x1EE55, 0 /* Other */],
    [/*start*/ 0x1EE57, 11 /* ALetter */],
    [/*start*/ 0x1EE58, 0 /* Other */],
    [/*start*/ 0x1EE59, 11 /* ALetter */],
    [/*start*/ 0x1EE5A, 0 /* Other */],
    [/*start*/ 0x1EE5B, 11 /* ALetter */],
    [/*start*/ 0x1EE5C, 0 /* Other */],
    [/*start*/ 0x1EE5D, 11 /* ALetter */],
    [/*start*/ 0x1EE5E, 0 /* Other */],
    [/*start*/ 0x1EE5F, 11 /* ALetter */],
    [/*start*/ 0x1EE60, 0 /* Other */],
    [/*start*/ 0x1EE61, 11 /* ALetter */],
    [/*start*/ 0x1EE63, 0 /* Other */],
    [/*start*/ 0x1EE64, 11 /* ALetter */],
    [/*start*/ 0x1EE65, 0 /* Other */],
    [/*start*/ 0x1EE67, 11 /* ALetter */],
    [/*start*/ 0x1EE6B, 0 /* Other */],
    [/*start*/ 0x1EE6C, 11 /* ALetter */],
    [/*start*/ 0x1EE73, 0 /* Other */],
    [/*start*/ 0x1EE74, 11 /* ALetter */],
    [/*start*/ 0x1EE78, 0 /* Other */],
    [/*start*/ 0x1EE79, 11 /* ALetter */],
    [/*start*/ 0x1EE7D, 0 /* Other */],
    [/*start*/ 0x1EE7E, 11 /* ALetter */],
    [/*start*/ 0x1EE7F, 0 /* Other */],
    [/*start*/ 0x1EE80, 11 /* ALetter */],
    [/*start*/ 0x1EE8A, 0 /* Other */],
    [/*start*/ 0x1EE8B, 11 /* ALetter */],
    [/*start*/ 0x1EE9C, 0 /* Other */],
    [/*start*/ 0x1EEA1, 11 /* ALetter */],
    [/*start*/ 0x1EEA4, 0 /* Other */],
    [/*start*/ 0x1EEA5, 11 /* ALetter */],
    [/*start*/ 0x1EEAA, 0 /* Other */],
    [/*start*/ 0x1EEAB, 11 /* ALetter */],
    [/*start*/ 0x1EEBC, 0 /* Other */],
    [/*start*/ 0x1F130, 11 /* ALetter */],
    [/*start*/ 0x1F14A, 0 /* Other */],
    [/*start*/ 0x1F150, 11 /* ALetter */],
    [/*start*/ 0x1F16A, 0 /* Other */],
    [/*start*/ 0x1F170, 11 /* ALetter */],
    [/*start*/ 0x1F18A, 0 /* Other */],
    [/*start*/ 0x1F1E6, 18 /* Regional_Indicator */],
    [/*start*/ 0x1F200, 0 /* Other */],
    [/*start*/ 0x1F3FB, 14 /* Extend */],
    [/*start*/ 0x1F400, 0 /* Other */],
    [/*start*/ 0x1FBF0, 9 /* Numeric */],
    [/*start*/ 0x1FBFA, 0 /* Other */],
    [/*start*/ 0xE0001, 13 /* Format */],
    [/*start*/ 0xE0002, 0 /* Other */],
    [/*start*/ 0xE0020, 14 /* Extend */],
    [/*start*/ 0xE0080, 0 /* Other */],
    [/*start*/ 0xE0100, 14 /* Extend */],
    [/*start*/ 0xE01F0, 0 /* Other */],
];
//# sourceMappingURL=WordBreakProperty.js.map